<!-- ══ NUEVO PLAN ═════════════════════════════════════════════════════════════
     Se fue la banda blanca a ancho completo del encabezado y el contenedor
     `w-full`: el título arrancaba pegado al borde de la ventana mientras el
     formulario de abajo empezaba en otro lado. Ahora todo vive dentro del mismo
     ancho, con `kb-page`, igual que el listado y el detalle.
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="kb-page">
  <!-- Header superior -->
      <div class="flex justify-between items-center gap-4">
        <!-- Botón volver -->
        <button (click)="goBack()" class="flex items-center text-muted-foreground hover:text-foreground transition-colors">
          <i class="fas fa-arrow-left mr-2"></i>
          <span>Volver</span>
        </button>

        <!-- Título central -->
        <h1 class="kb-page-title">Crear Nuevo Plan</h1>

        <!-- Indicador de progreso y acciones -->
        <div class="flex items-center space-x-4">
          <span class="text-sm text-muted-foreground">Paso {{ currentStep }} de {{ totalSteps }}</span>
          <div class="w-32 bg-muted rounded-full h-2">
            <div class="bg-primary h-2 rounded-full transition-all duration-300"
              [style.width.%]="getProgressPercentage()">
            </div>
          </div>

          <!-- Indicador de Modo de Navegación (solo para desarrollo) -->
          <div class="flex items-center space-x-2 px-3 py-1 rounded-full text-xs"
            [class]="enforceSequentialNavigation ? 'bg-destructive/10 text-destructive' : 'kb-caja-exito kb-texto-exito'">
            <i [class]="enforceSequentialNavigation ? 'fas fa-lock' : 'fas fa-unlock'"></i>
            <span>{{ enforceSequentialNavigation ? 'Secuencial' : 'Libre' }}</span>
            <button (click)="toggleNavigationMode()" class="ml-1 rounded p-1 hover:bg-accent"
              title="Cambiar modo de navegación">
              <i class="fas fa-sync-alt text-xs"></i>
            </button>
          </div>

          <button (click)="saveAndExit()" [disabled]="isSaving"
            class="kb-btn kb-btn-outline">
            <span *ngIf="!isSaving">Guardar y Salir</span>
            <span *ngIf="isSaving" class="flex items-center">
              <i class="fas fa-spinner fa-spin mr-2"></i>
              Guardando...
            </span>
          </button>
        </div>
      </div>

  <!-- LAYOUT 3 COLUMNAS PRINCIPAL
       🔴 La grilla era `grid-cols-12` PELADA, sin corte responsive: en un
       monitor chico o en una tablet las tres columnas seguían siendo tres, y el
       formulario del medio quedaba en un canal de 300 px. Ahora apila. -->
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-6">

      <!-- COLUMNA IZQUIERDA: Navegación lateral -->
      <div class="lg:col-span-3">
        <div class="kb-card p-6 h-fit">
          <h3 class="text-lg font-semibold text-foreground mb-6">Pasos del Wizard</h3>

          <div class="space-y-4">
            <!-- 🔴 El `cursor-pointer` ya no es fijo: en modo secuencial no se
                 puede saltar a un paso que esta mas adelante que el avance, y
                 antes esos pasos igual se veian clickeables y no hacian NADA al
                 tocarlos. Ahora se ven apagados y dicen por que. -->
            <div *ngFor="let step of getVisibleSteps(); trackBy: trackByPaso"
              class="flex items-center p-3 rounded-lg transition-all duration-200"
              [class.cursor-pointer]="pasoAlcanzable(step.number)"
              [class.cursor-not-allowed]="!pasoAlcanzable(step.number)"
              [class.opacity-50]="!pasoAlcanzable(step.number)"
              [title]="pasoAlcanzable(step.number)
                       ? 'Ir a ' + step.title
                       : 'Todavía no: primero hay que completar los pasos anteriores'"
              [ngClass]="getStepNavClasses(step.number)" (click)="goToStep(step.number)">

              <!-- Icono del paso -->
              <div class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center mr-3"
                [ngClass]="getStepIconClasses(step.number)">
                <i *ngIf="isStepCompleted(step.number)" class="fas fa-check text-sm"></i>
                <i *ngIf="currentStep === step.number && !isStepCompleted(step.number)"
                  class="fas fa-circle text-xs"></i>
                <i *ngIf="currentStep !== step.number && !isStepCompleted(step.number)"
                  class="far fa-circle text-xs"></i>
              </div>

              <!-- Título del paso -->
              <div class="flex-1">
                <div class="text-sm font-medium" [ngClass]="getStepTitleClasses(step.number)">
                  {{ step.title }}
                </div>
                <div *ngIf="currentStep === step.number" class="kb-hint">
                  Paso actual
                </div>
              </div>

              <!-- Indicador de estado -->
              <div class="flex-shrink-0">
                <span *ngIf="isStepCompleted(step.number)" class="kb-texto-exito">
                  <i class="fas fa-check-circle"></i>
                </span>
                <span *ngIf="currentStep === step.number && !isStepCompleted(step.number)" class="text-primary">
                  <i class="fas fa-arrow-right"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- COLUMNA CENTRAL: Contenido del paso activo -->
      <div class="lg:col-span-9">
        <div class="kb-card min-h-[600px]">

          <!-- Header del contenido -->
          <div class="px-6 py-4 border-b border-border">
            <div class="flex items-center">
              <div [class]="getCurrentStepIconClasses()"
                class="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center mr-4">
                <i [class]="getCurrentStepIcon() + 'text-lg'"></i>
              </div>
              <div>
                <h2 class="text-xl font-semibold text-foreground">{{ getCurrentStepTitle() }}</h2>
                <p class="text-sm text-muted-foreground mt-1">{{ getCurrentStepDescription() }}</p>
              </div>
            </div>
          </div>

          <!-- Contenido dinámico del paso -->
          <div class="px-6 py-6">

            <!-- PASO 1: ETIQUETAS -->
            <form *ngIf="currentStep === 1" [formGroup]="step1Form">
              <div class="space-y-6">

                <!-- Modo de Filtro -->
                <div>
                  <label class="block text-sm font-medium text-foreground mb-3">
                    Modo de Filtro <span class="text-destructive">*</span>
                  </label>

                  <div class="grid grid-cols-2 gap-3">
                    <label class="relative cursor-pointer">
                      <input type="radio" formControlName="filterMode" value="whitelist" class="sr-only peer">
                      <div
                        class="p-4 border border-border rounded-lg peer-checked:border-primary peer-checked:kb-caja-exito hover:border-border transition-colors text-center">
                        <i class="fas fa-check-circle kb-texto-exito text-2xl mb-2"></i>
                        <div class="text-sm font-medium text-foreground">Lista Blanca</div>
                        <div class="text-xs text-muted-foreground">Solo permitir</div>
                      </div>
                    </label>
                    <label class="relative cursor-pointer">
                      <input type="radio" formControlName="filterMode" value="blacklist" class="sr-only peer">
                      <div
                        class="p-4 border border-border rounded-lg peer-checked:border-destructive peer-checked:bg-destructive/5 hover:border-border transition-colors text-center">
                        <i class="fas fa-times-circle text-destructive text-2xl mb-2"></i>
                        <div class="text-sm font-medium text-foreground">Lista Negra</div>
                        <div class="text-xs text-muted-foreground">Excluir</div>
                      </div>
                    </label>
                  </div>

                  <!-- Error de modo de filtro -->
                  <div *ngIf="step1Form.get('filterMode')?.invalid && step1Form.get('filterMode')?.touched"
                    class="mt-2 text-sm text-destructive">
                    <i class="fas fa-exclamation-circle mr-1"></i>
                    Debe seleccionar un modo de filtro
                  </div>
                </div>

                <!-- Selector de Etiquetas -->
                <div>
                  <label class="block text-sm font-medium text-foreground mb-3">
                    Etiquetas
                    <span *ngIf="step1Form.get('filterMode')?.value === 'whitelist'" class="text-destructive">*</span>
                  </label>

                  <!-- Campo de búsqueda -->
                  <div class="relative">
                    <input type="text" placeholder="Buscar etiquetas..." (input)="onTagSearch($event)"
                      (focus)="onTagSearchFocus()" (blur)="hideTagDropdown()" [disabled]="tagsLoading"
                      class="kb-input">
                    <i class="fas fa-search absolute right-3 top-3 text-muted-foreground" *ngIf="!tagsLoading"></i>
                    <i class="fas fa-spinner fa-spin absolute right-3 top-3 text-muted-foreground" *ngIf="tagsLoading"></i>

                    <!-- Dropdown de etiquetas -->
                    <div *ngIf="showTagDropdown && filteredTags.length > 0"
                      class="absolute z-50 w-full mt-1 bg-card border border-border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                      <div *ngFor="let tag of filteredTags" (mousedown)="selectTag(tag)"
                        class="px-4 py-2 hover:bg-primary/5 cursor-pointer border-b border-border last:border-b-0">
                        <div class="flex items-center">
                          <i class="fas fa-tag text-primary text-sm mr-2"></i>
                          <span class="text-sm text-foreground">{{ tag }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- Mensaje de no resultados -->
                    <div *ngIf="showTagDropdown && filteredTags.length === 0 && tagSearchTerm.length > 0"
                      class="absolute z-50 w-full mt-1 bg-card border border-border rounded-lg shadow-lg p-4 text-center">
                      <i class="fas fa-search text-muted-foreground text-lg mb-2"></i>
                      <p class="text-sm text-muted-foreground">No se encontraron etiquetas para "{{ tagSearchTerm }}"</p>
                    </div>

                    <!-- Mensaje cuando no hay etiquetas disponibles -->
                    <div *ngIf="!tagsLoading && availableTags.length === 0"
                      class="absolute z-50 w-full mt-1 bg-card border border-border rounded-lg shadow-lg p-4 text-center">
                      <i class="fas fa-database text-muted-foreground text-lg mb-2"></i>
                      <p class="text-sm text-muted-foreground">No hay etiquetas disponibles en el sistema</p>
                      <p class="kb-hint">Contacte al administrador para agregar códigos dinámicos</p>
                    </div>
                  </div>

                  <!-- Etiquetas seleccionadas -->
                  <div class="mt-3 min-h-[100px] p-4 border-2 border-dashed border-border rounded-lg">
                    <div *ngIf="step1Form.get('selectedTags')?.value?.length === 0"
                      class="text-center text-muted-foreground py-8">
                      <i class="fas fa-tags text-3xl mb-2"></i>
                      <p>No hay etiquetas seleccionadas</p>
                      <p class="text-sm">Busque y seleccione etiquetas arriba</p>
                    </div>

                    <!-- Tokens de etiquetas -->
                    <div class="flex flex-wrap gap-2">
                      <span *ngFor="let tag of step1Form.get('selectedTags')?.value"
                        class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-primary/10 text-foreground border border-border">
                        <i class="fas fa-tag text-xs mr-1"></i>
                        {{ tag }}
                        <button type="button" (click)="removeTag(tag)"
                          class="ml-2 text-primary hover:text-foreground hover:bg-primary/20 rounded-full p-1 transition-colors"
                          title="Eliminar etiqueta">
                          <i class="fas fa-times text-xs"></i>
                        </button>
                      </span>
                    </div>
                  </div>

                  <!-- Error de etiquetas -->
                  <div *ngIf="step1Form.get('selectedTags')?.invalid && step1Form.get('selectedTags')?.touched"
                    class="mt-2 text-sm text-destructive">
                    <i class="fas fa-exclamation-circle mr-1"></i>
                    Para Lista Blanca debe seleccionar al menos una etiqueta
                  </div>
                </div>

                <!-- Audiencia Estimada -->
                <div class="bg-muted/40 p-4 rounded-lg">
                  <div class="flex items-center justify-between">
                    <div>
                      <h4 class="text-sm font-medium text-foreground">Audiencia Estimada</h4>
                      <p class="kb-hint">Cálculo aproximado de usuarios elegibles</p>
                    </div>
                    <div class="text-right">
                      <div class="text-2xl font-bold text-primary">
                        {{ getEstimatedAudience() | number }}
                      </div>
                      <div class="text-xs text-muted-foreground">usuarios</div>
                    </div>
                  </div>

                  <!-- Desglose -->
                  <div class="mt-3 pt-3 border-t border-border" *ngIf="step1Form.get('filterMode')?.value">
                    <div class="flex items-center text-xs text-muted-foreground">
                      <i class="fas fa-info-circle mr-1"></i>
                      <span *ngIf="step1Form.get('filterMode')?.value === 'whitelist'">
                        Solo usuarios CON {{ step1Form.get('selectedTags')?.value?.length || 0 }} etiqueta(s)
                        seleccionada(s)
                      </span>
                      <span *ngIf="step1Form.get('filterMode')?.value === 'blacklist'">
                        Todos los usuarios EXCEPTO {{ step1Form.get('selectedTags')?.value?.length || 0 }} etiqueta(s)
                        excluida(s)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!-- PASO 2: PENALIDADES (FEES) -->
            <div *ngIf="currentStep === 2" class="step-content">
              <div class="mb-6">
                <h3 class="text-xl font-semibold text-foreground mb-2">Configurar Penalidades (Fees)</h3>
                <p class="text-muted-foreground mb-4">
                  Configura las listas de penalidades (fees) que se aplicarán en este plan. Este paso es completamente
                  opcional.
                </p>
              </div>

              <form [formGroup]="step2Form" class="space-y-6">
                <div class="kb-caja-alerta border rounded-lg p-6">
                  <h4 class="text-lg font-medium kb-texto-alerta mb-4 flex items-center">
                    <i class="fas fa-dollar-sign kb-texto-alerta mr-2"></i>
                    Listas de Penalidades
                  </h4>

                  <div class="space-y-4">
                    <!-- White List Fees -->
                    <div>
                      <label class="kb-label">
                        Lista Blanca de Fees (Permitidos)
                      </label>
                      <p class="text-xs text-muted-foreground mb-2">Selecciona los fees que SÍ se aplicarán en este plan</p>
                      <!-- Aquí irá el selector de fees white list -->
                    </div>

                    <!-- Black List Fees -->
                    <div>
                      <label class="kb-label">
                        Lista Negra de Fees (Excluidos)
                      </label>
                      <p class="text-xs text-muted-foreground mb-2">Selecciona los fees que NO se aplicarán en este plan</p>
                      <!-- Aquí irá el selector de fees black list -->
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- Paso 3: Productos -->
            <div *ngIf="currentStep === 3" class="step-content">
              <div class="mb-6">
                <h3 class="text-xl font-semibold text-foreground mb-2">Seleccionar Productos</h3>
                <p class="text-muted-foreground mb-4">
                  Selecciona los productos e identificadores que estarán disponibles en este plan.
                  Puedes agregar múltiples combinaciones de producto + identificador.
                </p>
              </div>

              <form [formGroup]="step2Form" class="space-y-6">
                <!-- Sección de Selección -->
                <div class="bg-primary/5 border border-primary/30 rounded-lg p-6">
                  <h4 class="text-lg font-medium text-primary mb-4 flex items-center">
                    <i class="fas fa-search text-primary mr-2"></i>
                    Buscar y Seleccionar
                  </h4>

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <!-- Campo de Búsqueda de Productos -->
                    <div class="relative">
                      <label class="kb-label">
                        Buscar Producto <span class="text-destructive">*</span>
                      </label>
                      <div class="relative">
                        <input type="text" placeholder="Buscar productos..."
                          class="kb-input"
                          (input)="onProductSearch($event)" (focus)="onProductSearchFocus()"
                          (blur)="hideProductDropdown()" [disabled]="productsLoading" />
                        <div class="absolute right-3 top-3">
                          <i *ngIf="productsLoading" class="fas fa-spinner fa-spin text-muted-foreground"></i>
                          <i *ngIf="!productsLoading" class="fas fa-search text-muted-foreground"></i>
                        </div>
                      </div>

                      <!-- Dropdown de Productos -->
                      <div *ngIf="showProductDropdown"
                        class="absolute z-10 w-full mt-1 bg-card border border-border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                        <div *ngIf="filteredProducts.length === 0" class="px-4 py-3 text-muted-foreground text-center">
                          No se encontraron productos
                        </div>
                        <div *ngFor="let product of filteredProducts"
                          class="px-4 py-3 hover:bg-primary/10 cursor-pointer border-b border-border last:border-b-0"
                          (click)="selectProduct(product)">
                          <div class="font-medium text-foreground">{{ product.name }}</div>
                          <div class="text-sm text-muted-foreground">{{ product.code }}</div>
                          <div *ngIf="product.description" class="kb-hint">
                            {{ product.description }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Campo de Búsqueda de Identificadores -->
                    <div class="relative">
                      <label class="kb-label">
                        Buscar Identificador <span class="text-destructive">*</span>
                      </label>
                      <div class="relative">
                        <input type="text" placeholder="Buscar identificadores..."
                          class="kb-input"
                          (input)="onIdentifierSearch($event)" (focus)="onIdentifierSearchFocus()"
                          (blur)="hideIdentifierDropdown()" [disabled]="!selectedProduct || identifiersLoading" />
                        <div class="absolute right-3 top-3">
                          <i *ngIf="identifiersLoading" class="fas fa-spinner fa-spin text-muted-foreground"></i>
                          <i *ngIf="!identifiersLoading && !selectedProduct" class="fas fa-lock text-muted-foreground"
                            title="Selecciona un producto primero"></i>
                          <i *ngIf="!identifiersLoading && selectedProduct" class="fas fa-search text-muted-foreground"></i>
                        </div>
                      </div>

                      <!-- Dropdown de Identificadores -->
                      <div *ngIf="showIdentifierDropdown && selectedProduct"
                        class="absolute z-10 w-full mt-1 bg-card border border-border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                        <div *ngIf="filteredIdentifiers.length === 0" class="px-4 py-3 text-muted-foreground text-center">
                          No se encontraron identificadores
                        </div>
                        <div *ngFor="let identifier of filteredIdentifiers"
                          class="px-4 py-3 hover:bg-primary/10 cursor-pointer border-b border-border last:border-b-0"
                          (click)="selectIdentifier(identifier)">
                          <div class="font-medium text-foreground">{{ identifier.name }}</div>
                          <div class="text-sm text-muted-foreground">{{ identifier.code }}</div>
                          <div *ngIf="identifier.description" class="kb-hint">
                            {{ identifier.description }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Información de Selección Actual -->
                  <div *ngIf="selectedProduct || selectedIdentifier"
                    class="kb-card p-4 mb-4">
                    <h5 class="text-sm font-medium text-foreground mb-2">Selección Actual:</h5>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                      <div>
                        <span class="text-muted-foreground">Producto:</span>
                        <span class="ml-2 font-medium text-foreground">{{ selectedProduct?.name || 'No seleccionado'
                          }}</span>
                      </div>
                      <div>
                        <span class="text-muted-foreground">Identificador:</span>
                        <span class="ml-2 font-medium text-foreground">{{ selectedIdentifier?.name || 'No seleccionado'
                          }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Mensaje de carga de propuestas -->
                  <div *ngIf="loadingInsuranceProposals"
                    class="kb-caja-alerta border rounded-lg p-4 mb-4">
                    <div class="flex items-center">
                      <i class="fas fa-spinner fa-spin kb-texto-alerta mr-3 text-xl"></i>
                      <div>
                        <p class="text-sm font-semibold kb-texto-alerta">Cargando propuestas...</p>
                        <p class="text-xs kb-texto-alerta">Por favor espere, se están cargando las propuestas de seguros
                          disponibles</p>
                      </div>
                    </div>
                  </div>

                  <!-- Select para propuestas de aseguradoras (solo se muestra para productos de seguros) -->
                  <div *ngIf="showInsuranceProposals && !loadingInsuranceProposals"
                    class="bg-primary/5 border border-primary/30 rounded-lg p-4 mb-4">
                    <div class="mb-4">
                      <label class="kb-label">
                        Propuestas de Aseguradoras <span class="text-destructive">*</span>
                      </label>
                      
                      <!-- Mensaje de error cuando no hay propuestas disponibles -->
                      <div *ngIf="insuranceProposals.length === 0" class="bg-destructive/5 border border-destructive/30 rounded-lg p-4 mb-3">
                        <div class="flex items-start">
                          <i class="fas fa-exclamation-triangle text-destructive mt-0.5 mr-3"></i>
                          <div>
                            <p class="text-sm font-semibold text-destructive mb-1">
                              No hay propuestas disponibles
                            </p>
                            <p class="text-xs text-destructive">
                              No se encontraron propuestas de seguros para este producto. Por favor, verifica que:
                            </p>
                            <ul class="text-xs text-destructive list-disc list-inside mt-2 ml-2">
                              <li>El producto tenga propuestas configuradas en el sistema</li>
                              <li>La aseguradora esté correctamente vinculada</li>
                              <li>El identificador tenga el código de producto de seguro correcto</li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <select
                        name="insuranceProposal"
                        [(ngModel)]="selectedProposal"
                        [ngModelOptions]="{standalone: true}"
                        (change)="onProposalChange($event)"
                        [disabled]="insuranceProposals.length === 0"
                        class="kb-input">
                        <option value="">{{ insuranceProposals.length === 0 ? 'No hay propuestas disponibles' : 'Seleccionar propuesta' }}</option>
                        <option *ngFor="let proposal of insuranceProposals" [value]="proposal.code">
                          {{proposal.name}}{{proposal.deUso ? ' - ' + proposal.deUso : ''}} - {{proposal.mtPrima || proposal.description || proposal.code}}
                        </option>
                      </select>
                      <p class="kb-hint">
                        Selecciona la propuesta de aseguradora correspondiente a este producto de seguros
                      </p>
                      <p class="text-xs text-primary mt-1 font-semibold">
                        Propuestas disponibles: {{ insuranceProposals.length }}
                      </p>
                      <p class="text-xs text-primary mt-1 font-semibold">
                        Propuesta seleccionada: {{ selectedProposal || 'Ninguna' }}
                      </p>
                    </div>
                  </div>

                  <!-- Botón Agregar -->
                  <div class="flex justify-center">
                    <button type="button" (click)="addProductToList()"
                      [disabled]="!canAddProduct() || loadingInsuranceProposals"
                      class="px-6 py-2 kb-punto-exito text-primary-foreground rounded-lg hover:opacity-90 disabled:bg-muted disabled:cursor-not-allowed flex items-center">
                      <i class="fas fa-plus mr-2"></i>
                      {{ loadingInsuranceProposals ? 'Cargando propuestas...' : 'Agregar Producto' }}
                    </button>
                  </div>
                </div>

                <!-- Lista de Productos Agregados -->
                <div class="bg-muted/40 border border-border rounded-lg p-6">
                  <h4 class="text-lg font-medium text-foreground mb-4 flex items-center justify-between">
                    <span class="flex items-center">
                      <i class="fas fa-list text-muted-foreground mr-2"></i>
                      Productos Agregados
                    </span>
                    <span class="text-sm font-normal text-muted-foreground">
                      {{ getAddedProductsText() }}
                    </span>
                  </h4>

                  <!-- Estado Vacío -->
                  <div *ngIf="addedProducts.length === 0" class="text-center py-8">
                    <i class="fas fa-box-open text-muted-foreground text-4xl mb-4"></i>
                    <p class="text-muted-foreground mb-2">No hay productos agregados</p>
                    <p class="text-sm text-muted-foreground">Selecciona un producto e identificador para comenzar</p>
                  </div>

                  <!-- Lista de Productos -->
                  <div *ngIf="addedProducts.length > 0" class="space-y-3">
                    <div *ngFor="let item of addedProducts; let i = index"
                      class="kb-card flex items-center justify-between p-4">
                      <div class="flex-1">
                        <div class="flex items-center space-x-4">
                          <div class="flex-1">
                            <div class="font-medium text-foreground">{{ item.product.name }}</div>
                            <div class="text-sm text-muted-foreground">{{ item.product.code }}</div>
                          </div>
                          <div class="text-muted-foreground">
                            <i class="fas fa-arrow-right"></i>
                          </div>
                          <div class="flex-1">
                            <div class="font-medium text-primary">{{ item.identifier.name }}</div>
                            <div class="text-sm text-primary">{{ item.identifier.code }}</div>
                          </div>
                          <!-- Mostrar propuesta de seguros si existe -->
                          <div *ngIf="item.insuranceProposal" class="flex-1">
                            <div class="text-muted-foreground">
                              <i class="fas fa-arrow-right"></i>
                            </div>
                            <div class="font-medium kb-texto-exito flex items-center">
                              <i class="fas fa-shield-alt mr-2"></i>
                              Propuesta
                            </div>
                            <div class="text-sm kb-texto-exito">
                              {{ item.insuranceProposal.name || item.insuranceProposal }} - {{
                              item.insuranceProposal.mtPrima || '' }}
                            </div>
                            <div class="kb-hint">
                              ID: {{ item.insuranceProposal.code || item.insuranceProposal }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <button type="button" (click)="removeProductFromList(i)"
                        class="ml-4 p-2 text-destructive hover:bg-destructive/10 rounded-lg" title="Eliminar producto">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- PASO 4: Datos Básicos -->
            <div *ngIf="currentStep === 4" class="step-content">
              <form [formGroup]="step4Form" class="space-y-6">

                <!-- Tipo de Plan - PRIMER CAMPO -->
                <div class="mb-5">
                  <label class="block text-sm font-semibold text-foreground mb-3">
                    <span class="text-destructive">*</span> Tipo de Plan
                  </label>
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div class="relative h-full">
                      <input type="radio" id="plan-contado" value="cash" formControlName="planType"
                        (change)="onPlanTypeChange()" class="sr-only peer">
                      <label for="plan-contado"
                        class="flex flex-col items-center justify-center p-6 h-full min-h-[160px] bg-card border-2 border-border rounded-lg cursor-pointer hover:bg-accent/60 peer-checked:border-primary peer-checked:bg-primary/5 peer-checked:text-primary transition-all duration-200">
                        <i class="fas fa-money-bill-wave text-3xl mb-3 kb-texto-exito"></i>
                        <span class="text-lg font-semibold">De Contado</span>
                        <span class="text-sm text-muted-foreground text-center mt-1">Pago único y completo</span>
                      </label>
                    </div>
                    <div class="relative h-full">
                      <input type="radio" id="plan-credito" value="credit" formControlName="planType"
                        (change)="onPlanTypeChange()" class="sr-only peer">
                      <label for="plan-credito"
                        class="flex flex-col items-center justify-center p-6 h-full min-h-[160px] bg-card border-2 border-border rounded-lg cursor-pointer hover:bg-accent/60 peer-checked:border-primary peer-checked:bg-primary/5 peer-checked:text-primary transition-all duration-200">
                        <i class="fas fa-credit-card text-3xl mb-3 text-primary"></i>
                        <span class="text-lg font-semibold">A Crédito</span>
                        <span class="text-sm text-muted-foreground text-center mt-1">Financiamiento con cuotas</span>
                      </label>
                    </div>
                    <div class="relative h-full">
                      <input type="radio" id="plan-suscripcion" value="suscripcion" formControlName="planType"
                        (change)="onPlanTypeChange()" class="sr-only peer">
                      <label for="plan-suscripcion"
                        class="flex flex-col items-center justify-center p-6 h-full min-h-[160px] bg-card border-2 border-border rounded-lg cursor-pointer hover:bg-accent/60 peer-checked:border-primary peer-checked:bg-primary/5 peer-checked:text-primary transition-all duration-200">
                        <i class="fas fa-sync-alt text-3xl mb-3 text-primary"></i>
                        <span class="text-lg font-semibold">Suscripción</span>
                        <span class="text-sm text-muted-foreground text-center mt-1">Pagos recurrentes automáticos</span>
                      </label>
                    </div>
                  </div>
                  <div *ngIf="step3Form.get('planType')?.invalid && step3Form.get('planType')?.touched"
                    class="mt-2 text-sm text-destructive">
                    <i class="fas fa-exclamation-circle mr-1"></i>
                    Debe seleccionar el tipo de plan
                  </div>
                </div>

                <!-- Estatus - SEGUNDO CAMPO (TOGGLE) -->
                <div class="mb-5">
                  <label class="block text-sm font-semibold text-foreground mb-3">
                    <span class="text-destructive">*</span> Estatus del Plan
                  </label>
                  <div class="flex items-center justify-between p-4 bg-muted/40 rounded-lg">
                    <div class="flex items-center">
                      <i class="fas fa-info-circle text-primary mr-3"></i>
                      <div>
                        <span class="text-sm font-medium text-foreground">
                          {{ step3Form.get('status')?.value === 'true' ? 'Plan Activo' : 'Plan Inactivo' }}
                        </span>
                        <p class="kb-hint">
                          {{ step3Form.get('status')?.value === 'true' ? 'Disponible para clientes' : 'Recomendado para
                          nuevos planes' }}
                        </p>
                      </div>
                    </div>
                    <label class="relative inline-flex items-center cursor-pointer">
                      <input type="checkbox" [checked]="step3Form.get('status')?.value === 'true'"
                        (change)="onStatusToggle($event)" class="sr-only peer">
                      <div
                        class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary">
                      </div>
                    </label>
                  </div>
                  <div class="mt-2 text-xs text-muted-foreground bg-primary/5 p-3 rounded-lg">
                    <i class="fas fa-lightbulb text-primary mr-2"></i>
                    <strong>Recomendación:</strong> Cree el plan como "Inactivo" para revisar la configuración antes de
                    activarlo.
                  </div>
                </div>

                <!-- Información Básica -->
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

                  <!-- Nombre del Plan -->
                  <div class="mb-5">
                    <label for="planName" class="kb-label">
                      <span class="text-destructive">*</span> Nombre del Plan
                    </label>
                    <input type="text" id="planName" formControlName="planName"
                      class="kb-input"
                      placeholder="Ej: Plan Básico de Contado" maxlength="100">
                    <div *ngIf="step3Form.get('planName')?.invalid && step3Form.get('planName')?.touched"
                      class="mt-1 text-sm text-destructive">
                      <i class="fas fa-exclamation-circle mr-1"></i>
                      El nombre del plan es obligatorio
                    </div>
                    <div class="kb-hint">
                      Este será el nombre visible para los clientes
                    </div>
                  </div>

                  <!-- Código del Plan -->
                  <div class="mb-5">
                    <label for="planCode" class="kb-label">
                      <span class="text-destructive">*</span> Código del Plan
                    </label>
                    <input type="text" id="planCode" formControlName="planCode"
                      class="kb-input font-mono"
                      placeholder="Ej: PLAN-CONTADO-001" maxlength="50" (input)="onPlanCodeChange($event)"
                      (blur)="onPlanCodeBlur()">
                    <div *ngIf="step4Form.get('planCode')?.invalid && step4Form.get('planCode')?.touched"
                      class="mt-1 text-sm text-destructive">
                      <i class="fas fa-exclamation-circle mr-1"></i>
                      <span *ngIf="step4Form.get('planCode')?.errors?.['required']">El código del plan es
                        obligatorio</span>
                      <span *ngIf="step4Form.get('planCode')?.errors?.['pattern']">Solo se permiten letras, números,
                        guiones y guiones bajos</span>
                      <span *ngIf="step4Form.get('planCode')?.errors?.['duplicate']">Este código ya existe, elija
                        otro</span>
                    </div>
                    <!-- Indicador de validación en curso -->
                    <div *ngIf="isCheckingCode" class="mt-1 text-xs text-primary">
                      <i class="fas fa-spinner fa-spin mr-1"></i>
                      Verificando disponibilidad del código...
                    </div>
                    <!-- Mensaje de código disponible -->
                    <div *ngIf="codeCheckResult && !codeCheckResult.exists && !step4Form.get('planCode')?.errors"
                      class="mt-1 text-xs kb-texto-exito">
                      <i class="fas fa-check-circle mr-1"></i>
                      {{ codeCheckResult.message }}
                    </div>
                    <div class="kb-hint">
                      <i class="fas fa-lock mr-1"></i>
                      Identificador único e inmutable del sistema
                    </div>
                  </div>

                </div>

                <!-- Descripción -->
                <div class="mb-5">
                  <label for="description" class="kb-label">
                    Descripción
                    <span class="text-muted-foreground font-normal">(Opcional)</span>
                  </label>
                  <textarea id="description" formControlName="description" rows="4"
                    class="kb-textarea resize-none"
                    placeholder="Describe los beneficios y características del plan para los clientes..."
                    maxlength="1000"></textarea>
                  <div class="mt-1 text-xs text-muted-foreground flex justify-between">
                    <span>Soporta formato HTML básico</span>
                    <span>{{ step3Form.get('description')?.value?.length || 0 }}/1000</span>
                  </div>
                </div>

                <!-- Configuración Avanzada -->
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">

                  <!-- Icono -->
                  <div class="mb-5">
                    <label for="icon" class="kb-label">
                      Icono
                      <span class="text-muted-foreground font-normal">(Opcional)</span>
                    </label>
                    <div class="flex">
                      <span
                        class="inline-flex items-center px-3 text-sm text-foreground bg-muted border border-r-0 border-border rounded-l-lg">
                        <i [class]="step3Form.get('icon')?.value || 'fas fa-star'" class="text-muted-foreground"></i>
                      </span>
                      <input type="text" id="icon" formControlName="icon"
                        class="rounded-none rounded-r-lg bg-muted/40 border border-border text-foreground focus:ring-ring focus:border-ring block flex-1 min-w-0 w-full text-sm p-2.5"
                        placeholder="fas fa-star">
                    </div>
                    <div class="kb-hint">
                      Clase CSS de FontAwesome para personalización visual
                    </div>
                  </div>

                  <!-- Prioridad -->
                  <div class="mb-5">
                    <label for="priority" class="kb-label">
                      <span class="text-destructive" *ngIf="!isInsuranceProduct()">*</span> Prioridad
                      <span class="text-xs text-muted-foreground ml-1" *ngIf="isInsuranceProduct()">(Opcional para
                        seguros)</span>
                    </label>
                    <input type="number" id="priority" formControlName="priority" min="0" max="999"
                      class="kb-input"
                      placeholder="1">
                    <div *ngIf="step4Form.get('priority')?.invalid && step4Form.get('priority')?.touched"
                      class="mt-1 text-sm text-destructive">
                      <i class="fas fa-exclamation-circle mr-1"></i>
                      La prioridad debe ser un número entre 0 y 999
                    </div>
                    <div class="kb-hint">
                      Mayor número = mayor prioridad de sugerencia<span *ngIf="isInsuranceProduct()"> (Opcional para
                        planes de seguros)</span>
                    </div>
                  </div>

                  <!-- Multicompra - Solo para planes a crédito -->
                  <div class="mb-5" *ngIf="isPlanTypeCredit()">
                    <label class="kb-label">
                      Multicompra
                    </label>
                    <div class="flex items-center">
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="multicompra" class="sr-only peer">
                        <div
                          class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary">
                        </div>
                        <span class="ml-3 text-sm text-foreground">
                          {{ step3Form.get('multicompra')?.value ? 'Permitido' : 'Una sola vez por cliente' }}
                        </span>
                      </label>
                    </div>
                    <div class="kb-hint">
                      Define si un cliente puede usar este plan múltiples veces
                    </div>
                  </div>

                </div>

                <!-- Fechas de Vigencia -->
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

                  <!-- Fecha de Inicio -->
                  <div class="mb-5">
                    <label for="startDate" class="kb-label">
                      <span class="text-destructive">*</span> Fecha de Inicio
                    </label>
                    <input type="date" id="startDate" formControlName="startDate" [min]="getTodayDate()"
                      class="kb-input">
                    <div *ngIf="step3Form.get('startDate')?.invalid && step3Form.get('startDate')?.touched"
                      class="mt-1 text-sm text-destructive">
                      <i class="fas fa-exclamation-circle mr-1"></i>
                      <span *ngIf="step3Form.get('startDate')?.errors?.['required']">
                        La fecha de inicio es obligatoria
                      </span>
                    </div>
                    <div class="kb-hint">
                      Fecha desde la cual el plan estará disponible
                    </div>
                  </div>

                  <!-- Fecha de Finalización -->
                  <div class="mb-5">
                    <label for="endDate" class="kb-label">
                      Fecha de Finalización
                      <span class="text-muted-foreground font-normal">(Opcional)</span>
                    </label>
                    <input type="date" id="endDate" formControlName="endDate" [min]="getTodayDate()"
                      class="kb-input">
                    <div *ngIf="step3Form.get('endDate')?.invalid && step3Form.get('endDate')?.touched"
                      class="mt-1 text-sm text-destructive">
                      <i class="fas fa-exclamation-circle mr-1"></i>
                      La fecha de finalización debe ser posterior a la fecha de inicio
                    </div>
                    <div class="kb-hint">
                      Si se define, el plan se inactivará automáticamente en esta fecha
                    </div>
                  </div>

                </div>

                <!-- Información sobre el tipo de plan seleccionado -->
                <div *ngIf="step3Form.get('planType')?.value" class="mt-6 p-4 rounded-lg border-l-4"
                  [class.border-primary]="step3Form.get('planType')?.value === 'cash'"
                  [class.kb-caja-exito]="step3Form.get('planType')?.value === 'cash'"
                  [class.border-primary]="step3Form.get('planType')?.value === 'credit'"
                  [class.kb-fondo-marca-suave]="step3Form.get('planType')?.value === 'credit'"
                  [class.border-primary]="step3Form.get('planType')?.value === 'suscripcion'"
                  [class.kb-fondo-suave]="step3Form.get('planType')?.value === 'suscripcion'">

                  <div class="flex items-start">
                    <i class="fas fa-info-circle mt-1 mr-3"
                      [class.kb-texto-exito]="step3Form.get('planType')?.value === 'cash'"
                      [class.text-primary]="step3Form.get('planType')?.value === 'credit'"
                      [class.text-primary]="step3Form.get('planType')?.value === 'suscripcion'"></i>
                    <div>
                      <h4 class="text-sm font-semibold mb-2"
                        [class.kb-texto-exito]="step3Form.get('planType')?.value === 'cash'"
                        [class.text-primary]="step3Form.get('planType')?.value === 'credit'"
                        [class.text-foreground]="step3Form.get('planType')?.value === 'suscripcion'">
                        <span *ngIf="step3Form.get('planType')?.value === 'cash'">Plan de Contado Seleccionado</span>
                        <span *ngIf="step3Form.get('planType')?.value === 'credit'">Plan a Crédito Seleccionado</span>
                        <span *ngIf="step3Form.get('planType')?.value === 'suscripcion'">Plan de Suscripción
                          Seleccionado</span>
                      </h4>

                      <div *ngIf="step3Form.get('planType')?.value === 'cash'" class="text-sm kb-texto-exito">
                        <p class="mb-2">Este tipo de plan configurará automáticamente:</p>
                        <ul class="list-disc list-inside space-y-1 ml-4">
                          <li>Pago único del 100% del valor de la transacción</li>
                          <li>Sin configuración de cuotas ni términos financieros</li>
                          <li>Filtros solo por tipo de persona (no por tienda)</li>
                          <li>Sin configuración de vencimientos en feriados</li>
                        </ul>
                      </div>

                      <div *ngIf="step3Form.get('planType')?.value === 'credit'" class="text-sm text-primary">
                        <p class="mb-2">Este tipo de plan permitirá configurar:</p>
                        <ul class="list-disc list-inside space-y-1 ml-4">
                          <li>Términos financieros completos (inicial, cuotas, frecuencia)</li>
                          <li>Límites de financiamiento y requisitos de cupo</li>
                          <li>Filtros por persona y por tienda</li>
                          <li>Configuración avanzada de vencimientos</li>
                        </ul>
                      </div>

                      <div *ngIf="step3Form.get('planType')?.value === 'suscripcion'" class="text-sm text-foreground">
                        <p class="mb-2">Este tipo de plan permitirá configurar:</p>
                        <ul class="list-disc list-inside space-y-1 ml-4">
                          <li>Términos financieros completos (inicial, cuotas, frecuencia)</li>
                          <li>Límites de financiamiento sin requisitos de cupo</li>
                          <li>Filtros por persona y por tienda</li>
                          <li>Configuración avanzada de vencimientos</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </form>
            </div>

            <!-- PASO 5: DATOS GENERALES -->
            <div *ngIf="currentStep === 5" class="space-y-12">
              <form [formGroup]="step5Form">

                <!-- Pago Inicial -->
                <div class="kb-card p-6 mb-8" formGroupName="initialPayment">
                  <div class="flex items-center justify-between mb-6">
                    <div>
                      <h3 class="text-lg font-semibold text-foreground">Pago Inicial</h3>
                      <p class="text-sm text-muted-foreground mt-1">Configure si el plan requiere un pago por adelantado</p>
                    </div>
                    <label class="relative inline-flex items-center cursor-pointer">
                      <input type="checkbox" formControlName="required" (change)="onFinancingFieldChange()"
                        class="sr-only peer">
                      <div
                        class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary">
                      </div>
                      <span class="ml-3 text-sm font-medium text-foreground">
                        {{ step5Form.get('initialPayment.required')?.value ? 'Requerido' : 'Opcional' }}
                      </span>
                    </label>
                  </div>

                  <div *ngIf="step5Form.get('initialPayment.required')?.value"
                    class="space-y-6 pt-4 border-t border-border">

                    <!-- Tipo de Cálculo -->
                    <div>
                      <label class="block text-sm font-medium text-foreground mb-3">
                        <span class="text-destructive">*</span> Forma de Cálculo
                      </label>
                      <div class="grid grid-cols-2 gap-3">
                        <label class="relative cursor-pointer">
                          <input type="radio" value="percentage" formControlName="calculationType"
                            (change)="onFinancingFieldChange()" class="sr-only peer">
                          <div
                            class="p-4 border border-border rounded-lg peer-checked:border-primary peer-checked:bg-primary/5 hover:border-border transition-colors">
                            <div class="text-center">
                              <div
                                class="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-2">
                                <span class="text-primary font-bold">%</span>
                              </div>
                              <div class="font-medium text-foreground">Porcentaje</div>
                              <div class="text-xs text-muted-foreground">Del valor total</div>
                            </div>
                          </div>
                        </label>

                        <label class="relative cursor-pointer">
                          <input type="radio" value="absolute" formControlName="calculationType"
                            (change)="onFinancingFieldChange()" class="sr-only peer">
                          <div
                            class="p-4 border border-border rounded-lg peer-checked:border-primary peer-checked:bg-primary/5 hover:border-border transition-colors">
                            <div class="text-center">
                              <div
                                class="w-8 h-8 kb-caja-exito rounded-full flex items-center justify-center mx-auto mb-2">
                                <span class="kb-texto-exito font-bold">$</span>
                              </div>
                              <div class="font-medium text-foreground">Monto Fijo</div>
                              <div class="text-xs text-muted-foreground">Valor absoluto</div>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>

                    <!-- Valor del Inicial -->
                    <div>
                      <label class="kb-label">
                        <span class="text-destructive">*</span>
                        {{ step5Form.get('initialPayment.calculationType')?.value === 'percentage' ? 'Porcentaje del
                        Inicial' : 'Monto del Inicial' }}
                      </label>
                      <div class="relative">
                        <div *ngIf="step5Form.get('initialPayment.calculationType')?.value === 'absolute'"
                          class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <span class="text-muted-foreground">$</span>
                        </div>
                        <input type="number" formControlName="value"
                          [min]="step5Form.get('initialPayment.calculationType')?.value === 'percentage' ? 1 : 0.01"
                          [max]="step5Form.get('initialPayment.calculationType')?.value === 'percentage' ? 100 : null"
                          step="0.01" (input)="onFinancingFieldChange()"
                          [class.pl-8]="step5Form.get('initialPayment.calculationType')?.value === 'absolute'"
                          [class.pr-8]="step5Form.get('initialPayment.calculationType')?.value === 'percentage'"
                          class="kb-input"
                          [placeholder]="step5Form.get('initialPayment.calculationType')?.value === 'percentage' ? '20' : '100.00'">
                        <div *ngIf="step5Form.get('initialPayment.calculationType')?.value === 'percentage'"
                          class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                          <span class="text-muted-foreground">%</span>
                        </div>
                      </div>
                    </div>

                    <!-- Recalcular Cuotas -->
                    <div class="flex items-center p-3 bg-muted/40 rounded-md">
                      <input type="checkbox" formControlName="recalculateInstallments"
                        class="h-4 w-4 text-primary focus:ring-ring border-border rounded">
                      <label class="ml-3 text-sm text-foreground">
                        Recalcular cuotas descontando el inicial del monto total
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Montos de Financiamiento -->
                <div class="kb-card p-6 mb-8" formGroupName="financing">
                  <div class="mb-6">
                    <h3 class="text-lg font-semibold text-foreground">Montos de Financiamiento</h3>
                    <p class="text-sm text-muted-foreground mt-1">Defina los límites mínimos y máximos de financiamiento</p>
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <!-- Monto Mínimo de Compra -->
                    <div>
                      <label class="kb-label">
                        <span class="text-destructive">*</span> Monto Mínimo de Compra
                      </label>
                      <div class="relative">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <span class="text-muted-foreground">$</span>
                        </div>
                        <input type="number" formControlName="minPurchaseAmount" min="0.01" step="0.01"
                          (input)="onFinancingFieldChange()"
                          class="kb-input pl-8"
                          placeholder="100.00">
                      </div>
                      <p class="kb-hint">Valor mínimo total de la transacción</p>
                    </div>

                    <!-- Monto Máximo a Financiar -->
                    <div>
                      <label class="kb-label">
                        <span class="text-destructive">*</span> Monto Máximo a Financiar
                      </label>
                      <div class="relative">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <span class="text-muted-foreground">$</span>
                        </div>
                        <input type="number" formControlName="maxFinanceAmount" min="0.01" step="0.01"
                          class="kb-input pl-8"
                          placeholder="5000.00">
                      </div>
                      <p class="kb-hint">Cantidad máxima que se puede financiar</p>
                    </div>
                  </div>

                  <!-- Monto Mínimo a Financiar - CALCULADO -->
                  <div class="mt-6">
                    <label class="kb-label">
                      Monto Mínimo a Financiar (Calculado)
                    </label>
                    <div class="relative">
                      <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <span class="text-muted-foreground">$</span>
                      </div>
                      <input type="text" [value]="calculateMinFinanceAmount() | number:'1.2-2'" readonly
                        class="w-full pl-8 pr-3 py-2 border border-border rounded-md bg-muted/40 text-foreground cursor-not-allowed"
                        placeholder="0.00">
                    </div>
                    <p class="kb-hint">Se calcula automáticamente según el monto de compra y el pago
                      inicial</p>
                  </div>

                  <!-- Información del Cálculo -->
                  <div class="mt-4 p-3 bg-primary/5 border border-primary/30 rounded-md">
                    <div class="flex items-start">
                      <div class="flex-shrink-0">
                        <svg class="h-5 w-5 text-primary" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clip-rule="evenodd"></path>
                        </svg>
                      </div>
                      <div class="ml-3">
                        <p class="text-sm text-primary">
                          <strong>Fórmula de Cálculo:</strong>
                        </p>
                        <p class="text-xs text-primary mt-1" *ngIf="step5Form.get('initialPayment.required')?.value">
                          <span *ngIf="step5Form.get('initialPayment.calculationType')?.value === 'percentage'">
                            Monto a Financiar = Monto de Compra - (Monto de Compra × {{
                            step5Form.get('initialPayment.value')?.value }}%)
                          </span>
                          <span *ngIf="step5Form.get('initialPayment.calculationType')?.value === 'absolute'">
                            Monto a Financiar = Monto de Compra - ${{ step5Form.get('initialPayment.value')?.value }}
                          </span>
                        </p>
                        <p class="text-xs text-primary mt-1" *ngIf="!step5Form.get('initialPayment.required')?.value">
                          Sin pago inicial: Monto a Financiar = Monto de Compra
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Plazos y Cuotas (Refactored) -->
                <div class="mb-8">
                  <app-payment-terms-builder [paymentTerms]="paymentTerms"
                    (paymentTermsChange)="onPaymentTermsChanged($event)"
                    (validityChange)="onPaymentTermsValidityChanged($event)">
                  </app-payment-terms-builder>
                </div>

                <!-- Requisitos de Cupo (Solo para Crédito) -->
                <div *ngIf="getSelectedPlanType() !== 'suscripcion'"
                  class="kb-card p-6 mb-8" formGroupName="quotaRequirements">
                  <div class="mb-6">
                    <h3 class="text-lg font-semibold text-foreground">
                      Requisitos de Cupo
                      <span class="text-sm font-normal text-muted-foreground">(Opcional)</span>
                    </h3>
                    <p class="text-sm text-muted-foreground mt-1">Defina restricciones basadas en el cupo crediticio del cliente
                    </p>
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label class="kb-label">Cupo Mínimo Requerido</label>
                      <div class="relative">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <span class="text-muted-foreground">$</span>
                        </div>
                        <input type="number" formControlName="minQuota" min="0" step="0.01"
                          class="kb-input pl-8"
                          placeholder="0.00">
                      </div>
                      <p class="kb-hint">Cupo mínimo que debe tener el cliente</p>
                    </div>

                    <div>
                      <label class="kb-label">Cupo Máximo Permitido</label>
                      <div class="relative">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <span class="text-muted-foreground">$</span>
                        </div>
                        <input type="number" formControlName="maxQuota" min="0" step="0.01"
                          class="kb-input pl-8"
                          placeholder="0.00">
                      </div>
                      <p class="kb-hint">Cupo máximo para ser elegible al plan</p>
                    </div>
                  </div>
                </div>

                <!-- Resumen de Configuración -->
                <div class="bg-muted/40 border border-border rounded-lg p-4">
                  <h4 class="text-sm font-semibold text-foreground mb-3">Resumen de Configuración</h4>
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                    <div class="flex justify-between">
                      <span class="text-muted-foreground">Pago inicial:</span>
                      <span class="font-medium text-foreground">
                        {{ step5Form.get('initialPayment.required')?.value ?
                        (step5Form.get('initialPayment.calculationType')?.value === 'percentage' ?
                        (step5Form.get('initialPayment.value')?.value + '%') :
                        ('$' + (step5Form.get('initialPayment.value')?.value | number:'1.2-2'))) :
                        'No requerido' }}
                      </span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-muted-foreground">Financiamiento:</span>
                      <span class="font-medium text-foreground">
                        ${{ calculateMinFinanceAmount() | number:'1.2-2' }} -
                        ${{ step5Form.get('financing.maxFinanceAmount')?.value | number:'1.2-2' }}
                      </span>
                    </div>
                    <div class="flex justify-between">
                      <span class="text-muted-foreground">Plazos:</span>
                      <span class="font-medium text-foreground">
                        {{ paymentTerms.length }} configurado(s)
                      </span>
                    </div>
                  </div>
                </div>

              </form>
            </div>

            <!-- PASO 6: FILTROS -->
            <div *ngIf="currentStep === 6" class="space-y-8">
              <form [formGroup]="step6Form">

                <!-- Header de la sección -->
                <div class="border border-border rounded-lg p-6 mb-8">
                  <div class="flex items-center">
                    <div class="flex-shrink-0">
                      <div class="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                        <i class="fas fa-filter text-primary text-xl"></i>
                      </div>
                    </div>
                    <div class="ml-4">
                      <h2 class="text-xl font-semibold text-foreground">Configuración de Filtros</h2>
                      <p class="text-sm text-muted-foreground mt-1">
                        Configure filtros independientes para personas y tiendas. Ambos tipos pueden coexistir
                        simultáneamente.
                      </p>
                    </div>
                  </div>

                  <!-- Resumen de filtros activos -->
                  <div class="mt-4 flex items-center justify-between">
                    <div class="flex items-center space-x-4">
                      <div class="flex items-center">
                        <div class="w-3 h-3 rounded-full mr-2"
                          [class]="arePersonFiltersEnabled() ? 'kb-punto-exito' : 'bg-muted'"></div>
                        <span class="text-sm text-foreground">Filtros de Persona</span>
                      </div>
                      <div class="flex items-center">
                        <div class="w-3 h-3 rounded-full mr-2"
                          [class]="areStoreFiltersEnabled() ? 'bg-primary' : 'bg-muted'"></div>
                        <span class="text-sm text-foreground">Filtros de Tienda</span>
                      </div>
                    </div>
                    <div class="text-sm text-muted-foreground">
                      {{ getFiltersConfigSummary() }}
                    </div>
                  </div>
                </div>

                <!-- FILTROS DE PERSONA -->
                <div class="kb-card overflow-hidden" formGroupName="personConfig">
                  <!-- Header con toggle -->
                  <div class="bg-muted/40 px-6 py-4 border-b border-border rounded-t-xl">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center">
                        <div class="w-10 h-10 kb-caja-exito rounded-lg flex items-center justify-center mr-4">
                          <i class="fas fa-user-friends kb-texto-exito"></i>
                        </div>
                        <div>
                          <h3 class="text-lg font-semibold text-foreground">Filtros de Persona</h3>
                          <p class="text-sm text-muted-foreground">Restricciones basadas en características de la persona</p>
                        </div>
                      </div>

                      <!-- Toggle para habilitar filtros de persona -->
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="enabled"
                          (change)="togglePersonFilters(step6Form.get('personConfig.enabled')?.value || false)"
                          class="sr-only peer">
                        <div
                          class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary">
                        </div>
                        <span class="ml-3 text-sm font-medium text-foreground">
                          {{ arePersonFiltersEnabled() ? 'Habilitado' : 'Deshabilitado' }}
                        </span>
                      </label>
                    </div>
                  </div>

                  <!-- Contenido de filtros de persona -->
                  <div *ngIf="arePersonFiltersEnabled()" class="p-6 space-y-6">

                    <!-- Tipo de Persona -->
                    <div class="border border-border rounded-lg p-4">
                      <div class="mb-4">
                        <label class="block text-sm font-medium text-foreground">Tipo de Persona Aplicable</label>
                        <p class="kb-hint">Selecciona el tipo de persona que puede acceder a este
                          plan</p>
                      </div>

                      <div class="grid grid-cols-2 gap-3">
                        <label class="relative cursor-pointer">
                          <input type="radio" value="natural" formControlName="personType" class="sr-only peer">
                          <div
                            class="p-4 border border-border rounded-lg peer-checked:border-primary peer-checked:bg-primary/5 hover:border-border transition-colors text-center">
                            <i class="fas fa-user text-primary text-2xl mb-2"></i>
                            <div class="text-sm font-medium text-foreground">Natural</div>
                            <div class="text-xs text-muted-foreground">Personas físicas</div>
                          </div>
                        </label>
                        <label class="relative cursor-pointer">
                          <input type="radio" value="juridica" formControlName="personType" class="sr-only peer">
                          <div
                            class="p-4 border border-border rounded-lg peer-checked:border-primary peer-checked:bg-primary/5 hover:border-border transition-colors text-center">
                            <i class="fas fa-building text-primary text-2xl mb-2"></i>
                            <div class="text-sm font-medium text-foreground">Jurídica</div>
                            <div class="text-xs text-muted-foreground">Empresas</div>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ══ COMERCIOS A LOS QUE APLICA EL PLAN ═══════════════════════════
                     🔴 La regla, y por eso está escrita en la pantalla y no sólo
                     en el código: **si no se agrega ninguno, el plan aplica a
                     todos los comercios.** Es la configuración por omisión y es
                     como funcionan hoy los planes que ya existen.

                     No lleva interruptor de «habilitado» ni lista blanca/negra a
                     propósito: la pregunta es una sola y la respuesta por omisión
                     ya es correcta. Un interruptor más sería una forma más de
                     dejarlo a medias —encendido y vacío— que no significa nada.
                     ══════════════════════════════════════════════════════════ -->
                <div class="kb-card mt-6" formGroupName="merchantConfig">
                  <div class="bg-muted/40 px-6 py-4 border-b border-border rounded-t-xl">
                    <div class="flex items-center">
                      <div class="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mr-4">
                        <i class="fas fa-building text-primary"></i>
                      </div>
                      <div>
                        <h3 class="text-lg font-semibold text-foreground">Comercios a los que aplica</h3>
                        <p class="text-sm text-muted-foreground">
                          Dejalo vacío y el plan aplica a <strong>todos</strong> los comercios.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="p-6 space-y-4">
                    <div class="relative">
                      <label class="kb-label">Buscar comercio</label>
                      <input type="text" [(ngModel)]="comercioBusqueda" [ngModelOptions]="{standalone: true}"
                        (input)="filtrarComercios()" (focus)="mostrarListaComercios = true"
                        (blur)="cerrarListaComercios()"
                        class="kb-input"
                        placeholder="Buscá por nombre o código del comercio…">

                      <div *ngIf="mostrarListaComercios && comerciosFiltrados.length > 0"
                        class="absolute z-30 w-full mt-2 bg-card border border-border rounded-md shadow-lg max-h-48 overflow-y-auto">
                        <div *ngFor="let comercio of comerciosFiltrados" (click)="elegirComercio(comercio)"
                          class="px-3 py-2 hover:bg-accent cursor-pointer border-b border-border last:border-b-0">
                          <div class="font-medium text-foreground">{{ comercio.name }}</div>
                          <div class="text-xs text-muted-foreground">{{ comercio.code }}</div>
                        </div>
                      </div>
                    </div>

                    <!-- Los elegidos -->
                    <div *ngIf="comerciosElegidos.length > 0">
                      <div class="text-sm font-medium text-foreground mb-2">
                        Aplica solo a {{ comerciosElegidos.length }} comercio(s)
                      </div>
                      <div class="flex flex-wrap gap-2">
                        <span *ngFor="let comercio of comerciosElegidos" class="kb-badge kb-badge-marca">
                          <i class="fas fa-building text-xs"></i>
                          {{ comercio.name }}
                          <button type="button" (click)="quitarComercio(comercio)"
                            class="ml-1 rounded-full p-0.5 transition-colors hover:bg-primary/20"
                            [title]="'Quitar ' + comercio.name">
                            <i class="fas fa-times text-xs"></i>
                          </button>
                        </span>
                      </div>
                    </div>

                    <!-- Vacío: NO es un error, es la configuración por omisión -->
                    <div *ngIf="comerciosElegidos.length === 0" class="kb-aviso kb-aviso-info">
                      <i class="fas fa-globe mt-0.5"></i>
                      <div>
                        <p class="kb-aviso-titulo">Este plan aplica a todos los comercios</p>
                        <p class="mt-1">
                          Agregá comercios acá arriba sólo si querés limitarlo a algunos.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- FILTROS DE TIENDA (Solo para planes de crédito) -->
                <div *ngIf="shouldShowStoreFilters()"
                  class="kb-card mt-6" formGroupName="storeConfig">
                  <!-- Header con toggle -->
                  <div class="bg-muted/40 px-6 py-4 border-b border-border rounded-t-xl">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center">
                        <div class="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mr-4">
                          <i class="fas fa-store text-primary"></i>
                        </div>
                        <div>
                          <h3 class="text-lg font-semibold text-foreground">Filtros de Tienda</h3>
                          <p class="text-sm text-muted-foreground">Restricciones basadas en tiendas específicas</p>
                        </div>
                      </div>

                      <!-- Toggle para habilitar filtros de tienda -->
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="enabled"
                          (change)="toggleStoreFilters(step6Form.get('storeConfig.enabled')?.value || false)"
                          class="sr-only peer">
                        <div
                          class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary">
                        </div>
                        <span class="ml-3 text-sm font-medium text-foreground">
                          {{ areStoreFiltersEnabled() ? 'Habilitado' : 'Deshabilitado' }}
                        </span>
                      </label>
                    </div>
                  </div>

                  <!-- Contenido de filtros de tienda -->
                  <div *ngIf="areStoreFiltersEnabled()" class="p-6 space-y-6">

                    <!-- Tipo de filtro de tienda -->
                    <div class="border border-border rounded-lg p-4">
                      <div class="mb-4">
                        <label class="block text-sm font-medium text-foreground">Tipo de Filtro</label>
                        <p class="kb-hint">Selecciona cómo aplicar el filtro de tiendas</p>
                      </div>
                      <div class="grid grid-cols-2 gap-3">
                        <label class="relative cursor-pointer">
                          <input type="radio" value="white_list" formControlName="filterType" class="sr-only peer">
                          <div
                            class="p-4 border border-border rounded-lg peer-checked:border-primary peer-checked:kb-caja-exito hover:border-border transition-colors text-center">
                            <i class="fas fa-check-circle kb-texto-exito text-2xl mb-2"></i>
                            <div class="text-sm font-medium text-foreground">Solo Permitir</div>
                            <div class="text-xs text-muted-foreground">Lista blanca</div>
                          </div>
                        </label>
                        <label class="relative cursor-pointer">
                          <input type="radio" value="black_list" formControlName="filterType" class="sr-only peer">
                          <div
                            class="p-4 border border-border rounded-lg peer-checked:border-destructive peer-checked:bg-destructive/5 hover:border-border transition-colors text-center">
                            <i class="fas fa-times-circle text-destructive text-2xl mb-2"></i>
                            <div class="text-sm font-medium text-foreground">Excluir</div>
                            <div class="text-xs text-muted-foreground">Lista negra</div>
                          </div>
                        </label>
                      </div>
                    </div>

                    <!-- Selector de tiendas -->
                    <div class="border border-border rounded-lg p-4">
                      <div class="mb-4">
                        <label class="block text-sm font-medium text-foreground">Seleccionar Tiendas</label>
                        <p class="kb-hint">Busca y selecciona las tiendas para aplicar el filtro</p>
                      </div>
                      <div class="relative">
                        <input type="text" [(ngModel)]="storeSearchTerm" [ngModelOptions]="{standalone: true}"
                          (input)="filterStores()" (focus)="showStoreDropdown = true"
                          class="kb-input"
                          placeholder="Buscar tienda por nombre, categoría o ciudad...">

                        <!-- Dropdown de tiendas -->
                        <div *ngIf="showStoreDropdown && filteredStores.length > 0"
                          class="absolute z-30 w-full mt-2 bg-card border border-border rounded-md shadow-lg max-h-48 overflow-y-auto">
                          <div *ngFor="let store of filteredStores" (click)="selectStore(store)"
                            class="px-3 py-2 hover:bg-accent cursor-pointer border-b border-border last:border-b-0">
                            <div class="font-medium text-foreground">{{ store.name }}</div>
                            <div class="text-xs text-muted-foreground">{{ store.category }} • {{ store.city }}</div>
                          </div>
                        </div>
                      </div>

                      <!-- Tiendas seleccionadas -->
                      <div *ngIf="step6Form.get('storeConfig.selectedStores')?.value?.length > 0" class="mt-4">
                        <div class="text-sm font-medium text-foreground mb-2">
                          Tiendas Seleccionadas ({{ step6Form.get('storeConfig.selectedStores')?.value?.length }})
                        </div>
                        <div class="min-h-[100px] p-4 border-2 border-dashed border-border rounded-lg bg-muted/40">
                          <div class="flex flex-wrap gap-2">
                            <span *ngFor="let store of step6Form.get('storeConfig.selectedStores')?.value"
                              class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-primary/10 text-primary border border-primary/30">
                              <i class="fas fa-store text-xs mr-1"></i>
                              {{ store.name }}
                              <button type="button" (click)="removeStore(store)"
                                class="ml-2 rounded-full p-1 text-primary transition-colors hover:bg-primary/20"
                                title="Eliminar tienda">
                                <i class="fas fa-times text-xs"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>

                      <!-- Estado vacío -->
                      <div *ngIf="!step6Form.get('storeConfig.selectedStores')?.value?.length" class="mt-4">
                        <div class="min-h-[100px] p-4 border-2 border-dashed border-border rounded-lg">
                          <div class="text-center text-muted-foreground py-8">
                            <i class="fas fa-store text-3xl mb-2"></i>
                            <p>No hay tiendas seleccionadas</p>
                            <p class="text-sm">Busque y seleccione tiendas arriba</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Mensaje informativo para planes de contado -->
                <div *ngIf="!shouldShowStoreFilters()" class="kb-caja-alerta border rounded-lg p-4 mt-6">
                  <div class="flex items-center">
                    <i class="fas fa-info-circle kb-texto-alerta mr-3"></i>
                    <div>
                      <h4 class="text-sm font-medium kb-texto-alerta">Filtros de Tienda No Disponibles</h4>
                      <p class="text-sm kb-texto-alerta mt-1">
                        Los filtros de tienda solo están disponibles para planes de crédito.
                        Para habilitar esta funcionalidad, seleccione "Plan de Crédito" en la sección de Datos Básicos.
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Filtro por Productos del Catálogo -->
                <div class="kb-card mt-6" formGroupName="productConfig">
                  <div class="p-6 border-b border-border">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center">
                        <div class="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mr-3">
                          <i class="fas fa-box-open text-primary"></i>
                        </div>
                        <div>
                          <h3 class="text-base font-semibold text-foreground">Filtro por Productos del Catálogo</h3>
                          <p class="text-sm text-muted-foreground">Restringe este plan a productos específicos del catálogo</p>
                        </div>
                      </div>
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="enabled" class="sr-only peer">
                        <div class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                      </label>
                    </div>
                  </div>

                  <div *ngIf="areProductFiltersEnabled()" class="p-6 space-y-6">
                    <!-- Tipo de filtro -->
                    <div class="border border-border rounded-lg p-4">
                      <div class="mb-4">
                        <label class="block text-sm font-medium text-foreground">Tipo de Filtro</label>
                        <p class="kb-hint">Selecciona cómo aplicar el filtro de productos</p>
                      </div>
                      <div class="grid grid-cols-2 gap-3">
                        <label class="relative cursor-pointer">
                          <input type="radio" value="white_list" formControlName="filterType" class="sr-only peer">
                          <div class="p-4 border border-border rounded-lg peer-checked:border-primary peer-checked:kb-caja-exito hover:border-border transition-colors text-center">
                            <i class="fas fa-check-circle kb-texto-exito text-2xl mb-2"></i>
                            <div class="text-sm font-medium text-foreground">Solo Permitir</div>
                            <div class="text-xs text-muted-foreground">Lista blanca</div>
                          </div>
                        </label>
                        <label class="relative cursor-pointer">
                          <input type="radio" value="black_list" formControlName="filterType" class="sr-only peer">
                          <div class="p-4 border border-border rounded-lg peer-checked:border-destructive peer-checked:bg-destructive/5 hover:border-border transition-colors text-center">
                            <i class="fas fa-times-circle text-destructive text-2xl mb-2"></i>
                            <div class="text-sm font-medium text-foreground">Excluir</div>
                            <div class="text-xs text-muted-foreground">Lista negra</div>
                          </div>
                        </label>
                      </div>
                    </div>

                    <!-- Modo de coincidencia -->
                    <div *ngIf="step6Form.get('productConfig.filterType')?.value" class="border border-border rounded-lg p-4">
                      <label class="kb-label">Modo de Coincidencia</label>
                      <!-- Opciones para WHITELIST -->
                      <select *ngIf="step6Form.get('productConfig.filterType')?.value === 'white_list'" formControlName="matchMode"
                        class="kb-input">
                        <option value="all">TODOS los productos de la lista deben estar en el carrito</option>
                        <option value="any">Con que AL MENOS UNO de la lista est&eacute; en el carrito, aplica</option>
                      </select>
                      <!-- Opciones para BLACKLIST -->
                      <select *ngIf="step6Form.get('productConfig.filterType')?.value === 'black_list'" formControlName="matchMode"
                        class="kb-input">
                        <option value="any">Si CUALQUIER producto del carrito est&aacute; en la lista negra, NO aplica</option>
                        <option value="all">Solo si TODOS los productos del carrito son prohibidos, NO aplica</option>
                      </select>
                    </div>

                    <!-- Permitir otros productos (solo whitelist) -->
                    <div *ngIf="step6Form.get('productConfig.filterType')?.value === 'white_list'" class="border border-border rounded-lg p-4">
                      <div class="flex items-center justify-between">
                        <div>
                          <label class="block text-sm font-medium text-foreground">&iquest;Permitir otros productos?</label>
                          <p class="kb-hint">&iquest;El carrito puede tener productos que NO est&aacute;n en la lista?</p>
                        </div>
                        <label class="relative inline-flex items-center cursor-pointer">
                          <input type="checkbox" formControlName="allowOthers" class="sr-only peer">
                          <div class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                        </label>
                      </div>
                    </div>

                    <!-- Ejemplo din&aacute;mico -->
                    <div *ngIf="step6Form.get('productConfig.filterType')?.value" class="bg-muted/40 rounded-lg p-4 border border-border">
                      <p class="text-xs font-semibold text-foreground mb-2"><i class="fas fa-flask mr-1"></i>Ejemplo - Lista: [Tel&eacute;fono 1, Tel&eacute;fono 2]</p>
                      <div class="space-y-1.5 text-xs text-muted-foreground">
                        <!-- WHITELIST + any + allowOthers -->
                        <ng-container *ngIf="step6Form.get('productConfig.filterType')?.value === 'white_list' && step6Form.get('productConfig.matchMode')?.value === 'any' && step6Form.get('productConfig.allowOthers')?.value === true">
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (Tel1 est&aacute; en la lista)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Almohada]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (Tel1 coincide, Almohada permitida)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Almohada]</span> &rarr; <span class="text-destructive font-semibold">NO</span> (ninguno coincide)</p>
                        </ng-container>
                        <!-- WHITELIST + any + !allowOthers -->
                        <ng-container *ngIf="step6Form.get('productConfig.filterType')?.value === 'white_list' && step6Form.get('productConfig.matchMode')?.value === 'any' && step6Form.get('productConfig.allowOthers')?.value === false">
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (Tel1 est&aacute; en la lista)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Almohada]</span> &rarr; <span class="text-destructive font-semibold">NO</span> (Almohada no est&aacute; en la lista)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Tel2]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (ambos en la lista)</p>
                        </ng-container>
                        <!-- WHITELIST + all + allowOthers -->
                        <ng-container *ngIf="step6Form.get('productConfig.filterType')?.value === 'white_list' && step6Form.get('productConfig.matchMode')?.value === 'all' && step6Form.get('productConfig.allowOthers')?.value === true">
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Tel2]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (ambos presentes)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Tel2, Almohada]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (ambos presentes, Almohada permitida)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1]</span> &rarr; <span class="text-destructive font-semibold">NO</span> (falta Tel2)</p>
                        </ng-container>
                        <!-- WHITELIST + all + !allowOthers -->
                        <ng-container *ngIf="step6Form.get('productConfig.filterType')?.value === 'white_list' && step6Form.get('productConfig.matchMode')?.value === 'all' && step6Form.get('productConfig.allowOthers')?.value === false">
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Tel2]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (exactamente los de la lista)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Tel2, Almohada]</span> &rarr; <span class="text-destructive font-semibold">NO</span> (Almohada no permitida)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1]</span> &rarr; <span class="text-destructive font-semibold">NO</span> (falta Tel2)</p>
                        </ng-container>
                        <!-- BLACKLIST + any -->
                        <ng-container *ngIf="step6Form.get('productConfig.filterType')?.value === 'black_list' && step6Form.get('productConfig.matchMode')?.value === 'any'">
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Almohada]</span> &rarr; <span class="text-destructive font-semibold">NO</span> (Tel1 est&aacute; prohibido)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Almohada]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (ning&uacute;n prohibido)</p>
                        </ng-container>
                        <!-- BLACKLIST + all -->
                        <ng-container *ngIf="step6Form.get('productConfig.filterType')?.value === 'black_list' && step6Form.get('productConfig.matchMode')?.value === 'all'">
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Tel2]</span> &rarr; <span class="text-destructive font-semibold">NO</span> (todos son prohibidos)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Tel1, Almohada]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (no todos son prohibidos)</p>
                          <p><span class="font-mono bg-card px-1 rounded">[Almohada]</span> &rarr; <span class="kb-texto-exito font-semibold">S&Iacute;</span> (ning&uacute;n prohibido)</p>
                        </ng-container>
                      </div>
                    </div>

                    <!-- Buscador de productos -->
                    <div class="border border-border rounded-lg p-4">
                      <div class="mb-4">
                        <label class="block text-sm font-medium text-foreground">Seleccionar Productos</label>
                        <p class="kb-hint">Busca en el catálogo o escribe un código manualmente y presiona Enter</p>
                      </div>
                      <div class="flex gap-2">
                        <div class="relative flex-1">
                          <input type="text" [(ngModel)]="catalogProductSearchTerm" [ngModelOptions]="{standalone: true}"
                            (input)="searchCatalogProducts()" (focus)="showCatalogProductDropdown = true"
                            (blur)="hideCatalogProductDropdown()" (keydown)="onProductSearchKeydown($event)"
                            class="kb-input"
                            placeholder="Buscar o escribir código de producto...">
                          <div *ngIf="catalogProductsLoading" class="absolute right-3 top-2.5">
                            <i class="fas fa-spinner fa-spin text-muted-foreground"></i>
                          </div>
                          <div *ngIf="showCatalogProductDropdown && filteredCatalogProducts.length > 0"
                            class="absolute z-30 w-full mt-2 bg-card border border-border rounded-md shadow-lg max-h-48 overflow-y-auto">
                            <div *ngFor="let product of filteredCatalogProducts" (mousedown)="selectCatalogProduct(product)"
                              class="px-3 py-2 hover:bg-accent cursor-pointer border-b border-border last:border-b-0">
                              <div class="font-medium text-foreground">{{ product.name }}</div>
                              <div class="text-xs text-muted-foreground">{{ product.code }} <span *ngIf="product.brand">&bull; {{ product.brand }}</span></div>
                            </div>
                          </div>
                        </div>
                        <button type="button" (click)="addManualProductCode()"
                          class="kb-btn kb-btn-outline whitespace-nowrap">
                          <i class="fas fa-plus mr-1"></i> Agregar
                        </button>
                      </div>

                      <!-- Acciones: Excel upload + Eliminar todos -->
                      <div class="flex items-center gap-3 mt-3">
                        <label class="inline-flex items-center px-3 py-1.5 kb-caja-exito kb-texto-exito border rounded-md hover:kb-caja-exito cursor-pointer transition-colors text-sm">
                          <i class="fas fa-file-excel mr-1.5"></i> Importar Excel
                          <input type="file" accept=".xlsx,.xls,.csv" (change)="onExcelFileSelected($event)" class="hidden">
                        </label>
                        <button type="button" *ngIf="step6Form.get('productConfig.selectedProducts')?.value?.length > 0"
                          (click)="removeAllCatalogProducts()"
                          class="inline-flex items-center px-3 py-1.5 bg-destructive/5 text-destructive border border-destructive/30 rounded-md hover:bg-destructive/10 transition-colors text-sm">
                          <i class="fas fa-trash-alt mr-1.5"></i> Eliminar todos ({{ step6Form.get('productConfig.selectedProducts')?.value?.length }})
                        </button>
                      </div>

                      <!-- Tabla de productos seleccionados -->
                      <div *ngIf="step6Form.get('productConfig.selectedProducts')?.value?.length > 0" class="mt-4">
                        <div class="text-sm font-medium text-foreground mb-2">
                          Productos Seleccionados ({{ step6Form.get('productConfig.selectedProducts')?.value?.length }})
                        </div>
                        <div class="border border-border rounded-lg overflow-hidden">
                          <div class="max-h-64 overflow-y-auto">
                            <table class="w-full text-sm">
                              <thead class="bg-muted/40 sticky top-0">
                                <tr>
                                  <th class="px-3 py-2 text-left font-medium text-muted-foreground">#</th>
                                  <th class="px-3 py-2 text-left font-medium text-muted-foreground">C&oacute;digo</th>
                                  <th class="px-3 py-2 text-left font-medium text-muted-foreground">Nombre</th>
                                  <th class="px-3 py-2 text-center font-medium text-muted-foreground">Acci&oacute;n</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let product of step6Form.get('productConfig.selectedProducts')?.value; let i = index"
                                  class="border-t border-border hover:bg-accent/60">
                                  <td class="px-3 py-2 text-muted-foreground">{{ i + 1 }}</td>
                                  <td class="px-3 py-2 font-mono text-foreground">{{ product.code }}</td>
                                  <td class="px-3 py-2 text-muted-foreground">
                                    <span *ngIf="product.name">{{ product.name }}</span>
                                    <span *ngIf="!product.name" class="text-muted-foreground italic">Código manual</span>
                                  </td>
                                  <td class="px-3 py-2 text-center">
                                    <button type="button" (click)="removeCatalogProduct(product)"
                                      class="text-destructive hover:text-destructive transition-colors" title="Eliminar">
                                      <i class="fas fa-times"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <!-- Estado vacío -->
                      <div *ngIf="!step6Form.get('productConfig.selectedProducts')?.value?.length" class="mt-4">
                        <div class="min-h-[80px] p-4 border-2 border-dashed border-border rounded-lg">
                          <div class="text-center text-muted-foreground py-4">
                            <i class="fas fa-box-open text-2xl mb-2"></i>
                            <p class="text-sm">No hay productos seleccionados</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Resumen final de filtros -->
                <div class="bg-muted/40 border border-border rounded-lg p-6 mt-8">
                  <h3 class="text-lg font-semibold text-foreground mb-4">
                    <i class="fas fa-chart-bar text-primary mr-2"></i>
                    Resumen de Configuración
                  </h3>

                  <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <!-- Filtros de Persona -->
                    <div class="kb-card p-4">
                      <div class="flex items-center justify-between mb-2">
                        <span class="text-sm font-medium text-foreground">Filtros de Persona</span>
                        <div class="w-3 h-3 rounded-full"
                          [class]="arePersonFiltersEnabled() ? 'kb-punto-exito' : 'bg-muted'"></div>
                      </div>
                      <div class="text-xs text-muted-foreground">
                        <div *ngIf="!arePersonFiltersEnabled()">Sin filtros configurados</div>
                        <div *ngIf="arePersonFiltersEnabled()">
                          {{ getActiveFiltersCount() }} filtro(s) activo(s)
                        </div>
                      </div>
                    </div>

                    <!-- Filtros de Tienda -->
                    <div class="kb-card p-4">
                      <div class="flex items-center justify-between mb-2">
                        <span class="text-sm font-medium text-foreground">Filtros de Tienda</span>
                        <div class="w-3 h-3 rounded-full"
                          [class]="areStoreFiltersEnabled() ? 'bg-primary' : 'bg-muted'"></div>
                      </div>
                      <div class="text-xs text-muted-foreground">
                        <div *ngIf="!shouldShowStoreFilters()">Solo para planes de crédito</div>
                        <div *ngIf="shouldShowStoreFilters() && !areStoreFiltersEnabled()">Sin filtros configurados
                        </div>
                        <div *ngIf="shouldShowStoreFilters() && areStoreFiltersEnabled()">
                          {{ step6Form.get('storeConfig.selectedStores')?.value?.length || 0 }} tienda(s)
                          seleccionada(s)
                        </div>
                      </div>
                    </div>

                    <!-- Filtros de Productos -->
                    <div class="kb-card p-4">
                      <div class="flex items-center justify-between mb-2">
                        <span class="text-sm font-medium text-foreground">Filtros de Productos</span>
                        <div class="w-3 h-3 rounded-full"
                          [class]="areProductFiltersEnabled() ? 'kb-punto-alerta' : 'bg-muted'"></div>
                      </div>
                      <div class="text-xs text-muted-foreground">
                        <div *ngIf="!areProductFiltersEnabled()">Sin filtros configurados</div>
                        <div *ngIf="areProductFiltersEnabled()">
                          {{ step6Form.get('productConfig.selectedProducts')?.value?.length || 0 }} producto(s) seleccionado(s)
                        </div>
                      </div>
                    </div>

                    <!-- Audiencia Estimada -->
                    <div class="kb-card p-4">
                      <div class="flex items-center justify-between mb-2">
                        <span class="text-sm font-medium text-foreground">Audiencia Estimada</span>
                        <i class="fas fa-users text-primary"></i>
                      </div>
                      <div class="text-lg font-semibold text-primary">
                        {{ getEstimatedAudience() | number }}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- PASO 7: OTROS -->
            <div *ngIf="currentStep === 7" class="space-y-8">
              <form [formGroup]="step7Form">

                <!-- Header de la sección -->
                <div class="border border-border rounded-lg p-6 mb-8">
                  <div class="flex items-center">
                    <div class="flex-shrink-0">
                      <div class="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                        <i class="fas fa-cog text-primary text-xl"></i>
                      </div>
                    </div>
                    <div class="ml-4">
                      <h2 class="text-xl font-semibold text-foreground">Configuraciones Adicionales</h2>
                      <p class="text-sm text-muted-foreground mt-1">
                        Gestione aspectos legales y administrativos del crédito. Define los requisitos de documentación
                        y las reglas de cobranza.
                      </p>
                    </div>
                  </div>
                </div>

                <!-- PAGARÉ ELECTRÓNICO -->
                <div class="kb-card p-6 mb-6">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center">
                      <div class="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mr-4">
                        <i class="fas fa-file-signature text-primary"></i>
                      </div>
                      <div>
                        <h3 class="text-lg font-semibold text-foreground">Pagaré Electrónico</h3>
                        <p class="text-sm text-muted-foreground">Habilitar la generación automática de pagarés electrónicos</p>
                      </div>
                    </div>

                    <!-- Toggle Pagaré Electrónico -->
                    <div class="flex items-center">
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="electronicPromissoryNote" class="sr-only peer">
                        <div
                          class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary">
                        </div>
                        <span class="ml-3 text-sm font-medium text-foreground">
                          {{ step7Form.get('electronicPromissoryNote')?.value ? 'Habilitado' : 'Deshabilitado' }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- PAGARÉ FÍSICO -->
                <div class="kb-card p-6 mb-6">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center">
                      <div class="w-10 h-10 kb-caja-exito rounded-lg flex items-center justify-center mr-4">
                        <i class="fas fa-file-alt kb-texto-exito"></i>
                      </div>
                      <div>
                        <h3 class="text-lg font-semibold text-foreground">Pagaré Físico</h3>
                        <p class="text-sm text-muted-foreground">Habilitar la generación automática de pagarés físicos</p>
                      </div>
                    </div>

                    <!-- Toggle Pagaré Físico -->
                    <div class="flex items-center">
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="physicalPromissoryNote" class="sr-only peer">
                        <div
                          class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary">
                        </div>
                        <span class="ml-3 text-sm font-medium text-foreground">
                          {{ step7Form.get('physicalPromissoryNote')?.value ? 'Habilitado' : 'Deshabilitado' }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- DIFERIR CUOTAS EN FINES DE SEMANA Y FERIADOS (Solo para crédito) -->
                <div *ngIf="isPlanTypeCredit()" class="kb-card p-6 mb-6">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center">
                      <div class="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mr-4">
                        <i class="fas fa-calendar-alt text-primary"></i>
                      </div>
                      <div>
                        <h3 class="text-lg font-semibold text-foreground">Diferir cuotas de fines de semana y feriados
                        </h3>
                        <p class="text-sm text-muted-foreground">Mover automáticamente las cuotas que caigan en fines de semana
                          o feriados al siguiente día hábil</p>
                      </div>
                    </div>

                    <!-- Toggle Fines de Semana y Feriados -->
                    <div class="flex items-center">
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="allowWeekendsAndHolidays" class="sr-only peer">
                        <div
                          class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary">
                        </div>
                        <span class="ml-3 text-sm font-medium text-foreground">
                          {{ step7Form.get('allowWeekendsAndHolidays')?.value ? 'Habilitado' : 'Deshabilitado' }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- VISIBILIDAD DEL PLAN AL CLIENTE -->
                <div class="kb-card p-6 mb-6">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center">
                      <div class="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mr-4">
                        <i class="fas fa-eye text-primary"></i>
                      </div>
                      <div>
                        <h3 class="text-lg font-semibold text-foreground">Visibilidad del Plan al Cliente</h3>
                        <p class="text-sm text-muted-foreground">Controlar si el plan es visible para los clientes en la
                          aplicación</p>
                      </div>
                    </div>

                    <!-- Toggle Visibilidad al Cliente -->
                    <div class="flex items-center">
                      <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="clientVisible" class="sr-only peer">
                        <div
                          class="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-card after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-card after:border-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary">
                        </div>
                        <span class="ml-3 text-sm font-medium text-foreground">
                          {{ step7Form.get('clientVisible')?.value ? 'Visible' : 'Oculto' }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Mensaje informativo para planes de contado -->
                <div *ngIf="!isPlanTypeCredit()" class="kb-caja-alerta border rounded-lg p-4 mb-6">
                  <div class="flex items-center">
                    <i class="fas fa-info-circle kb-texto-alerta mr-3"></i>
                    <div>
                      <h4 class="text-sm font-medium kb-texto-alerta">Configuración de Feriados No Aplicable</h4>
                      <p class="text-sm kb-texto-alerta mt-1">
                        La configuración de diferimiento de cuotas en fines de semana y feriados solo aplica para planes
                        de crédito.
                        Los planes de contado no tienen cuotas programadas.
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Resumen de configuración -->
                <div class="bg-muted/40 border border-border rounded-lg p-6">
                  <h3 class="text-lg font-semibold text-foreground mb-4">
                    <i class="fas fa-clipboard-list text-primary mr-2"></i>
                    Resumen de Configuración
                  </h3>

                  <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <!-- Pagaré Electrónico -->
                    <div class="kb-card p-4">
                      <div class="flex items-center justify-between mb-2">
                        <span class="text-sm font-medium text-foreground">Pagaré Electrónico</span>
                        <div class="w-3 h-3 rounded-full"
                          [class]="step6Form.get('electronicPromissoryNote')?.value ? 'bg-primary' : 'bg-muted'">
                        </div>
                      </div>
                      <div class="text-xs text-muted-foreground">
                        {{ step6Form.get('electronicPromissoryNote')?.value ? 'Habilitado' : 'Deshabilitado' }}
                      </div>
                    </div>

                    <!-- Pagaré Físico -->
                    <div class="kb-card p-4">
                      <div class="flex items-center justify-between mb-2">
                        <span class="text-sm font-medium text-foreground">Pagaré Físico</span>
                        <div class="w-3 h-3 rounded-full"
                          [class]="step6Form.get('physicalPromissoryNote')?.value ? 'kb-punto-exito' : 'bg-muted'">
                        </div>
                      </div>
                      <div class="text-xs text-muted-foreground">
                        {{ step6Form.get('physicalPromissoryNote')?.value ? 'Habilitado' : 'Deshabilitado' }}
                      </div>
                    </div>

                    <!-- Feriados (Solo para crédito) -->
                    <div class="kb-card p-4">
                      <div class="flex items-center justify-between mb-2">
                        <span class="text-sm font-medium text-foreground">Diferimiento de Cuotas</span>
                        <div class="w-3 h-3 rounded-full"
                          [class]="isPlanTypeCredit() && step6Form.get('allowWeekendsAndHolidays')?.value ? 'bg-primary' : 'bg-muted'">
                        </div>
                      </div>
                      <div class="text-xs text-muted-foreground">
                        <span *ngIf="!isPlanTypeCredit()">Solo para crédito</span>
                        <span *ngIf="isPlanTypeCredit()">
                          {{ step6Form.get('allowWeekendsAndHolidays')?.value ? 'Permitido' : 'No Permitido' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- PASO 8: FINALIZAR -->
            <div *ngIf="currentStep === 8">
              <form [formGroup]="step8Form">
                <!-- Header con gradiente e icono -->
                <div class="rounded-lg p-6 mb-6 text-primary-foreground">
                  <div class="flex items-center">
                    <div class="bg-white/20 p-3 rounded-full mr-4">
                      <i class="fas fa-flag-checkered text-2xl"></i>
                    </div>
                    <div>
                      <h3 class="text-xl font-semibold mb-1">Paso 7: Finalizar Plan</h3>
                      <p class="text-primary-foreground">Revisión final y confirmación antes de crear el plan</p>
                    </div>
                  </div>
                </div>

                <!-- Resumen del Plan -->
                <div class="bg-muted/40 border border-border rounded-lg p-6 mb-6">
                  <h4 class="text-lg font-semibold text-foreground mb-4 flex items-center">
                    <i class="fas fa-clipboard-list text-primary mr-2"></i>
                    Resumen del Plan
                  </h4>

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <!-- Información básica -->
                    <div class="space-y-3">
                      <div class="flex justify-between">
                        <span class="text-sm font-medium text-muted-foreground">Nombre:</span>
                        <span class="text-sm text-foreground">{{ getPlanSummary().name }}</span>
                      </div>
                      <div class="flex justify-between">
                        <span class="text-sm font-medium text-muted-foreground">Código:</span>
                        <span class="text-sm text-foreground font-mono">{{ getPlanSummary().code }}</span>
                      </div>
                      <div class="flex justify-between">
                        <span class="text-sm font-medium text-muted-foreground">Tipo:</span>
                        <span class="text-sm text-foreground">
                          <span [ngClass]="{
                                  'bg-primary/10 text-primary': getPlanSummary().type === 'Crédito',
                                  'bg-primary/10 text-foreground': getPlanSummary().type === 'Suscripción',
                                  'kb-caja-exito kb-texto-exito': getPlanSummary().type === 'Contado'
                                }" class="px-2 py-1 rounded-full text-xs font-medium">
                            {{ getPlanSummary().type }}
                          </span>
                        </span>
                      </div>
                      <div class="flex justify-between">
                        <span class="text-sm font-medium text-muted-foreground">Estado:</span>
                        <span class="text-sm text-foreground">
                          <span
                            [class]="getPlanSummary().status === 'Activo' ? 'kb-caja-exito kb-texto-exito' : 'bg-muted text-foreground'"
                            class="px-2 py-1 rounded-full text-xs font-medium">
                            {{ getPlanSummary().status }}
                          </span>
                        </span>
                      </div>
                    </div>

                    <!-- Productos y configuraciones -->
                    <div class="space-y-3">
                      <div class="flex justify-between">
                        <span class="text-sm font-medium text-muted-foreground">Productos:</span>
                        <span class="text-sm text-foreground">{{ getPlanSummary().productsCount }} producto(s)</span>
                      </div>

                      <!-- Configuraciones de crédito -->
                      <div *ngIf="getPlanSummary().type === 'Crédito'">
                        <div class="flex justify-between">
                          <span class="text-sm font-medium text-muted-foreground">Monto mínimo compra:</span>
                          <span class="text-sm text-foreground">${{ getPlanSummary().minPurchaseAmount?.toLocaleString()
                            }}</span>
                        </div>
                        <div class="flex justify-between">
                          <span class="text-sm font-medium text-muted-foreground">Monto máximo financiar:</span>
                          <span class="text-sm text-foreground">${{ getPlanSummary().maxFinanceAmount?.toLocaleString()
                            }}</span>
                        </div>
                        <div class="flex justify-between">
                          <span class="text-sm font-medium text-muted-foreground">Cuotas disponibles:</span>
                          <span class="text-sm text-foreground">{{ getPlanSummary().installmentOptions?.join(', ')
                            }}</span>
                        </div>
                      </div>

                      <div class="flex justify-between">
                        <span class="text-sm font-medium text-muted-foreground">Filtros configurados:</span>
                        <span class="text-sm text-foreground">
                          {{ (getPlanSummary().hasPersonFilters || getPlanSummary().hasStoreFilters) ? 'Sí' : 'No' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Texto de Conformidad -->
                <div class="bg-primary/5 border border-primary/30 rounded-lg p-6 mb-6">
                  <h4 class="text-lg font-semibold text-foreground mb-3 flex items-center">
                    <i class="fas fa-info-circle text-primary mr-2"></i>
                    Declaración de Conformidad
                  </h4>
                  <p class="text-sm text-primary leading-relaxed">
                    {{ getConformityText() }}
                  </p>
                </div>


                <!-- Checkboxes de Confirmación -->
                <div class="space-y-4 mb-6">
                  <div class="flex items-start">
                    <input type="checkbox" id="termsAccepted" formControlName="termsAccepted"
                      class="mt-1 h-4 w-4 kb-texto-exito focus:ring-ring border-border rounded">
                    <label for="termsAccepted" class="ml-3 text-sm text-foreground">
                      <span class="font-medium">Acepto los términos y condiciones</span>
                      <br>
                      <span class="text-muted-foreground">
                        Confirmo que he revisado toda la información del plan y acepto proceder con su creación.
                      </span>
                    </label>
                  </div>

                  <div class="flex items-start">
                    <input type="checkbox" id="reviewCompleted" formControlName="reviewCompleted"
                      class="mt-1 h-4 w-4 kb-texto-exito focus:ring-ring border-border rounded">
                    <label for="reviewCompleted" class="ml-3 text-sm text-foreground">
                      <span class="font-medium">Revisión completada</span>
                      <br>
                      <span class="text-muted-foreground">
                        He verificado que todos los datos son correctos y el plan está listo para ser creado.
                      </span>
                    </label>
                  </div>
                </div>

                <!-- Mensajes de validación -->
                <div *ngIf="step7Form.get('termsAccepted')?.invalid && step7Form.get('termsAccepted')?.touched"
                  class="mb-4 p-3 bg-destructive/5 border border-destructive/30 rounded-lg">
                  <p class="text-sm text-destructive flex items-center">
                    <i class="fas fa-exclamation-circle mr-2"></i>
                    Debe aceptar los términos y condiciones para continuar.
                  </p>
                </div>

                <div *ngIf="step7Form.get('reviewCompleted')?.invalid && step7Form.get('reviewCompleted')?.touched"
                  class="mb-4 p-3 bg-destructive/5 border border-destructive/30 rounded-lg">
                  <p class="text-sm text-destructive flex items-center">
                    <i class="fas fa-exclamation-circle mr-2"></i>
                    Debe confirmar que ha completado la revisión del plan.
                  </p>
                </div>

                <!-- Estado de guardado -->
                <div *ngIf="isSaving" class="mb-6 p-4 kb-caja-alerta border rounded-lg">
                  <div class="flex items-center">
                    <i class="fas fa-spinner fa-spin kb-texto-alerta mr-3"></i>
                    <div>
                      <h4 class="text-sm font-medium kb-texto-alerta">Creando plan...</h4>
                      <p class="text-sm kb-texto-alerta mt-1">
                        Por favor espere mientras se procesa la información y se crea el plan.
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>

          </div>

          <!-- SECCIÓN DINÁMICA INTERACTIVA SOBRE EL BOTÓN -->
          <div class="px-6 pb-6">

            <!-- Información de campos faltantes (solo en modo secuencial) -->
            <div *ngIf="enforceSequentialNavigation && getMissingRequiredFields().length > 0"
              class="mb-4 p-4 kb-caja-alerta border rounded-lg">
              <div class="flex items-start">
                <i class="fas fa-exclamation-triangle kb-texto-alerta mt-0.5 mr-3"></i>
                <div class="flex-1">
                  <h4 class="text-sm font-medium kb-texto-alerta mb-2">
                    Campos obligatorios faltantes para continuar:
                  </h4>
                  <ul class="text-sm kb-texto-alerta space-y-1">
                    <li *ngFor="let field of getMissingRequiredFields()" class="flex items-center">
                      <i class="fas fa-dot-circle text-xs mr-2"></i>
                      {{ field }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Información de paso completado (solo en modo secuencial) -->
            <div *ngIf="enforceSequentialNavigation && isStepCompletedSuccessfully()"
              class="mb-4 p-4 kb-caja-exito border rounded-lg">
              <div class="flex items-center">
                <i class="fas fa-check-circle kb-texto-exito mr-3"></i>
                <div>
                  <h4 class="text-sm font-medium kb-texto-exito">
                    ¡Paso completado correctamente!
                  </h4>
                  <p class="text-sm kb-texto-exito mt-1">
                    Todos los campos obligatorios han sido completados. Puede continuar al siguiente paso.
                  </p>
                </div>
              </div>
            </div>

            <!-- Información de modo libre -->
            <div *ngIf="!enforceSequentialNavigation" class="mb-4 p-4 bg-primary/5 border border-primary/30 rounded-lg">
              <div class="flex items-center">
                <i class="fas fa-unlock text-primary mr-3"></i>
                <div>
                  <h4 class="text-sm font-medium text-primary">
                    Modo de Navegación Libre Activo
                  </h4>
                  <p class="text-sm text-primary mt-1">
                    Puede navegar libremente entre pasos para pruebas. Use el botón 🔒 en el header para activar
                    validaciones.
                  </p>
                </div>
              </div>
            </div>

            <!-- Botones de navegación -->
            <div class="flex justify-between items-center">
              <button *ngIf="currentStep > 1" (click)="previousStep()"
                class="kb-btn kb-btn-outline">
                <i class="fas fa-arrow-left mr-2"></i>
                Anterior
              </button>

              <div class="flex-1"></div>

              <button *ngIf="currentStep < totalSteps" (click)="nextStep()" [disabled]="!canGoToNextStep()"
                [class]="getNextButtonClasses()"
                class="kb-btn">

                <!-- Contenido dinámico del botón según el modo -->
                <ng-container *ngIf="!enforceSequentialNavigation">
                  <!-- Modo libre: siempre "Siguiente" si es posible -->
                  <span *ngIf="canGoToNextStep()">
                    Siguiente
                    <i class="fas fa-arrow-right ml-2"></i>
                  </span>
                  <span *ngIf="!canGoToNextStep()">
                    Último paso
                    <i class="fas fa-flag-checkered ml-2"></i>
                  </span>
                </ng-container>

                <ng-container *ngIf="enforceSequentialNavigation">
                  <!-- Modo secuencial: depende de validaciones -->
                  <span *ngIf="isCurrentStepValid()">
                    Siguiente
                    <i class="fas fa-arrow-right ml-2"></i>
                  </span>

                  <span *ngIf="!isCurrentStepValid() && getMissingRequiredFields().length > 0">
                    Faltan {{ getMissingRequiredFields().length }} campos
                    <i class="fas fa-exclamation-triangle ml-2"></i>
                  </span>

                  <span *ngIf="!isCurrentStepValid() && getMissingRequiredFields().length === 0">
                    Completar información
                    <i class="fas fa-info-circle ml-2"></i>
                  </span>
                </ng-container>
              </button>

              <!-- Botón finalizar en el último paso -->
              <button *ngIf="currentStep === totalSteps" (click)="finalizePlan()"
                [disabled]="!isCurrentStepValid() || isSaving"
                class="flex items-center px-6 py-2 text-sm font-medium text-primary-foreground kb-punto-exito border border-transparent rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring disabled:opacity-50 disabled:cursor-not-allowed">
                <span *ngIf="!isSaving">
                  <i class="fas fa-check mr-2"></i>
                  Finalizar Plan
                </span>
                <span *ngIf="isSaving" class="flex items-center">
                  <i class="fas fa-spinner fa-spin mr-2"></i>
                  Creando Plan...
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- ══ GLOSARIO — APAGADO ═══════════════════════════════════════════════
           Ocupaba una columna fija de las 12, siempre, con texto explicativo.
           El formulario —que es a lo que se entra— quedaba en la mitad del
           ancho. Se apaga con *ngIf="false" y NO se borra: los términos siguen
           en `currentStepGlossary` dentro del componente, así que devolverlo es
           sacar esta línea. -->
      <div *ngIf="false" class="lg:col-span-3">
        <div class="kb-card p-6 sticky top-8">
          <h3 class="text-lg font-semibold text-foreground mb-4">
            <i class="fas fa-book text-primary mr-2"></i>
            Glosario
          </h3>

          <div class="space-y-4">
            <div *ngFor="let item of currentStepGlossary" class="border-b border-border pb-3 last:border-b-0">
              <dt class="text-sm font-medium text-foreground mb-1">{{ item.term }}</dt>
              <dd class="text-sm text-muted-foreground">{{ item.definition }}</dd>
            </div>

            <div *ngIf="currentStepGlossary.length === 0" class="text-center text-muted-foreground py-8">
              <i class="fas fa-book-open text-3xl mb-2"></i>
              <p>No hay términos disponibles para este paso</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- SECCIÓN TEMPORAL: JSON DEL PLAN EN TIEMPO REAL -->
  <!-- COMENTADO: JSON DEL PLAN EN TIEMPO REAL - OCULTADO POR SOLICITUD DEL USUARIO
  <div class="w-full px-6 pb-8">
    <div class="bg-gray-900 rounded-lg shadow-lg border border-gray-700 overflow-hidden">
      <div class="bg-gray-800 px-6 py-4 border-b border-gray-700">
        <div class="flex items-center justify-between">
          <div class="flex items-center">
            <i class="fas fa-code kb-texto-exito mr-3"></i>
            <h3 class="text-lg font-semibold text-primary-foreground">JSON del Plan (Tiempo Real)</h3>
            <span class="ml-3 px-2 py-1 kb-punto-alerta text-yellow-100 text-xs rounded-full">TEMPORAL</span>
          </div>
          <div class="flex items-center space-x-3">
            <span class="text-sm text-muted-foreground">Paso {{ currentStep }}/{{ totalSteps }}</span>
            <div class="flex items-center space-x-2">
              <div class="w-2 h-2 kb-punto-exito rounded-full animate-pulse"></div>
              <span class="text-xs text-muted-foreground">Actualizando</span>
            </div>
          </div>
        </div>
      </div>

      <div class="p-6">
        <div class="bg-gray-800 rounded-lg border border-gray-600 overflow-hidden">
          <div class="bg-gray-700 px-4 py-2 border-b border-gray-600">
            <div class="flex items-center justify-between">
              <span class="text-sm font-medium text-muted-foreground">Configuración del Plan</span>
              <div class="flex items-center space-x-2">
                <span class="text-xs text-muted-foreground">Válido:</span>
                <span class="text-xs" [class]="isCurrentStepValid() ? 'kb-texto-exito' : 'text-destructive'">
                  <i [class]="isCurrentStepValid() ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                  {{ isCurrentStepValid() ? 'Sí' : 'No' }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-4 max-h-96 overflow-y-auto">
            <pre class="text-sm text-muted-foreground whitespace-pre-wrap font-mono leading-relaxed">{{ getCurrentPlanJSONString() }}</pre>
          </div>
        </div>

        <div class="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4">
          <div class="bg-gray-800 rounded-lg p-3 border border-gray-600">
            <div class="text-xs text-muted-foreground mb-1">Pasos Completados</div>
            <div class="text-lg font-semibold text-primary-foreground">{{ completedSteps.length }}</div>
          </div>
          <div class="bg-gray-800 rounded-lg p-3 border border-gray-600">
            <div class="text-xs text-muted-foreground mb-1">Campos Faltantes</div>
            <div class="text-lg font-semibold" [class]="getMissingRequiredFields().length > 0 ? 'text-destructive' : 'kb-texto-exito'">
              {{ getMissingRequiredFields().length }}
            </div>
          </div>
          <div class="bg-gray-800 rounded-lg p-3 border border-gray-600">
            <div class="text-xs text-muted-foreground mb-1">Navegación</div>
            <div class="text-lg font-semibold" [class]="enforceSequentialNavigation ? 'text-destructive' : 'kb-texto-exito'">
              {{ enforceSequentialNavigation ? 'Secuencial' : 'Libre' }}
            </div>
          </div>
          <div class="bg-gray-800 rounded-lg p-3 border border-gray-600">
            <div class="text-xs text-muted-foreground mb-1">Audiencia Est.</div>
            <div class="text-lg font-semibold text-primary">{{ getEstimatedAudience() | number }}</div>
          </div>
        </div>

        <div class="mt-4 flex justify-end">
          <button
            (click)="copyJSONToClipboard()"
            class="flex items-center px-4 py-2 bg-primary hover:bg-primary text-primary-foreground text-sm font-medium rounded-lg transition-colors">
            <i class="fas fa-copy mr-2"></i>
            Copiar JSON
          </button>
        </div>
      </div>
    </div>
  </div>
  -->
</div>

<!-- LOADING INICIAL DEL PLAN -->